<template>
	<div class="vue-wrapper">
		<lane-closure-request-quick-nav v-if="!$store.state.isMobile" v-model="laneClosureRequest" selected="view"></lane-closure-request-quick-nav>
		<lane-closure-request-quick-nav-mobile :auditBatches="auditBatches" v-if="$store.state.isMobile" v-model="laneClosureRequest" selected="view"></lane-closure-request-quick-nav-mobile>
		<b-container v-if="getReminderNotifications().length > 0" class="laneclosure-view-notifiaction-container">
			<b-row :class="getReminderNotificationClass(getReminderNotifications())">
				<b-col>
					<span v-for="entry in getReminderNotifications()" :key="entry.id" class="view-notification-entry">
						<img src="/img/nav/icon-bell-circle.svg" alt="Updates" /> {{entry.text}}
					</span>
				</b-col>
			</b-row>
		</b-container>
		<b-container class="laneclosure-view-container" v-if="laneClosureRequest != null && loaded">
			<b-form v-if="!loadError">
				<b-row v-if="$store.state.isMobile && 1 == 2">
					<b-col v-if="$store.state.isMobile" class="pt-0 lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" xl="9">
						<div class="d-flex lcr-page-title" v-if="laneClosureRequest.isEmergency.value == 1">
							<div>
								<h1 v-if="laneClosureRequest.changeRequest">Requested Changes #{{laneClosureRequest.changeRequest.id}}</h1>
								<h1 v-else>No Changes Requested</h1>
							</div>
						</div>
						<div class="d-flex lcr-page-title" v-if="laneClosureRequest.isEmergency.value == 0">
							<div class="pt-lg-3 flex-grow-1">
								<h1 v-if="laneClosureRequest.changeRequest">Requested Changes #{{laneClosureRequest.changeRequest.id}}</h1>
								<h1 v-else>No Changes Requested</h1>
							</div>
						</div>
						<b-alert variant="danger" v-show="laneClosureRequest.warningMessage.value && canSeeWarning()" show>{{laneClosureRequest.warningMessage.value}}</b-alert>
					</b-col>
				</b-row>
				<b-row :class="$store.state.isMobile ? 'lcr-detail-mobile-wrapper' : ''">
					<b-col v-if="!$store.state.isMobile" class="pt-0 lcr-quick-nav-summary" sm="12" lg="9">
						<div class="d-flex" v-if="laneClosureRequest.isEmergency.value == 1">
							<div>
								<h1 v-if="laneClosureRequest.changeRequest">Requested Changes #{{laneClosureRequest.changeRequest.id}}</h1>
								<h1 v-else>No Changes Requested</h1>

							</div>
						</div>
						<div class="d-flex" v-if="laneClosureRequest.isEmergency.value == 0">
							<div class="pt-lg-3 flex-grow-1">
								<h1 v-if="laneClosureRequest.changeRequest">Requested Changes #{{laneClosureRequest.changeRequest.id}}</h1>
								<h1 v-else>No Changes Requested</h1>

							</div>
						</div>
						<b-row v-if="laneClosureRequest.requesterProjectName">
							<b-col class="pt-1">
								<h2>Project: {{laneClosureRequest.requesterProjectName}}</h2>
							</b-col>
						</b-row>
						<b-alert variant="danger" v-show="laneClosureRequest.warningMessage.value && canSeeWarning()" show>{{laneClosureRequest.warningMessage.value}}</b-alert>
						<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
						<!-- <div class="d-flex lcr-main-summary lcr-main-summary-mobile">

						<div class="lcr-main-summary__info">
							<div class="lcr-summary__label">Info</div>
							<div class="lcr-summary__value" v-show="laneClosureRequest.trafficManagementRef.value">TM: {{laneClosureRequest.trafficManagementRef.value}}</div>
							<div class="lcr-summary__value">LCR: {{laneClosureRequest.id}}</div>
						</div>
						<div class="lcr-main-summary__info flex-grow-1">
							<div class="lcr-summary__label">Affected Streets</div>
							<div class="lcr-summary__value">{{directionOfTravel}}</div>
							<div class="lcr-summary__value">{{laneClosureRequest.affectedStreet.value}}</div>
							<div class="lcr-summary__value">{{laneClosureRequest.firstCrossStreet.value}} to {{laneClosureRequest.lastCrossStreet.value}}</div>
						</div>
						<div class="lcr-main-summary__info pt-4" v-if="!$store.state.isMobile">
							<div class="show-on-map-wrapper">
								<a class="show-on-map text-left" @click="showOnMap">
									<span v-if="hideMap" class="on-container">
										<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
										<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
									</span>
									<span v-else class="on-container">
										<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
										<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
									</span>
								</a>
							</div>
						</div>
						<div class="lcr-main-summary__info">
							<div class="lcr-summary__label">Primary Reason for Closure</div>
							<div class="lcr-summary__value">{{natureOfWork}}</div>
						</div>
						<div class="lcr-main-summary__info ">
							<div class="lcr-summary__label">Date(s)</div>
							<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromDate.value, 'MM/DD/YYYY')}} - {{Format.toLocalDateTime(laneClosureRequest.toDate.value, 'MM/DD/YYYY')}}</div>
							<div class="lcr-summary__value">{{Format.toLocalDateTime(laneClosureRequest.fromDate.value, 'H:mm')}} - {{Format.toLocalDateTime(laneClosureRequest.toDate.value, 'H:mm')}}</div>
						</div>
						<div class="lcr-main-summary__info" v-if="laneClosureRequest.completeTypeId.value != null">
							<div class="lcr-summary__label">Complete Status</div>
							<div class="lcr-summary__value">{{LaneClosureRequest.getCompleteTypeIdText(laneClosureRequest.completeTypeId.value)}}</div>
						</div>
						<div class="lcr-main-summary__info">
							<div class="lcr-summary__label">Approval Status</div>
							<div class="lcr-summary__value">{{LaneClosureRequest.getApprovalStatusIdText(laneClosureRequest.approvalStatusId.value)}}</div>
							<div class="lcr-summary__label">Record Status</div>
							<div class="lcr-summary__value">{{LaneClosureRequest.getRecordStatusText(laneClosureRequest.recordStatusId.value)}}</div>
						</div>
						<div class="lcr-main-summary__info pt-4" v-if="$store.state.isMobile">
							<div class="show-on-map-wrapper">
								<a class="show-on-map text-left" @click="showOnMap">
									<span v-if="hideMap" class="on-container">
										<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
										<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
									</span>
									<span v-else class="on-container">
										<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
										<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
									</span>
								</a>
							</div>
						</div>

					</div> -->
					</b-col>
					<b-col v-if="$store.state.isMobile" class="pt-0 lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" xl="9">
						<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
					</b-col>
					<b-col v-if="!$store.state.isMobile" lg="3" class="lcr-main-actions">

						<b-row v-if="hasChangeRequest" >
							<b-col>
								<b-button class="mb-2 text-uppercase" variant="primary" block @click="onEditRequestedChanges">Edit Requested Changes
								</b-button>
							</b-col>
						</b-row>

						<b-row v-if="hasChangeRequest" >
							<b-col>
								<b-button class="mb-2 text-uppercase" variant="warning" block @click="onShowDiscardChangesModal">Discard Requested Changes
									<b-spinner small label="Saving..." class="ml-2" v-if="completeSaving" />
								</b-button>
							</b-col>
						</b-row>

					</b-col>
				</b-row>
				<b-row>
					<b-col xl="7" class="lcr-summary__left-column">
						<b-row v-if="laneClosureRequest.conflictsFromOthers.length > 0" :key="'conflicts-'+Math.random()">
							<b-col class="pt-2">
								<div :class="expandConflicts ? 'text-primary collapsible  collapsible__conflicts' : 'text-primary collapsible collapsed  collapsible__conflicts'">
									<div class="collapsible-heading p-0">
										<div class="d-flex bottom-border">
											<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpandConflicts">Conflicting with request</div>
											<div class="collapsible-heading__toggle" v-show="laneClosureRequest.conflicts.length > 0">
												<b-button href="#" variant="collapsible" :class="expandConflicts ? '' : 'collapsed'" :aria-expanded="expandConflicts ? 'true' : 'false'" aria-controls="collapseConflicts" @click="onToggleExpandConflicts">
													<span class="when-opened">
														<font-awesome-icon icon="chevron-down" />
													</span>
													<span class="when-closed">
														<font-awesome-icon icon="chevron-right" />
													</span>
												</b-button>
											</div>
										</div>
									</div>
									<b-collapse class="collapse--content" id="collapseConflicts" :visible="expandConflicts">
										<b-col>
											<div class="lcr-conflicts ">
												<div class="d-flex lcr-conflicts__entry" v-for="c in durationConflict" v-bind:key="'lcr-conflicts-entry-'+c.id+'-'+Math.random()">
													<div class="flex-grow-1">
														<b-link variant="link" v-if="c.trafficManagementRef > 0" @click="viewLaneClosureRequest(c.id)">Duration Conflict with TM: {{c.trafficManagementRef}}</b-link>
														<b-link variant="link" v-else @click="viewLaneClosureRequest(c.id)">Duration Conflict with LCR: {{c.id}}</b-link>
														<p><span>{{c.affectedStreet}} between {{c.firstCrossStreet}} and {{c.lastCrossStreet}}</span><br />
															<span>{{Format.toLocalDateTime(c.fromDate, 'MM/DD/YYYY H:mm')}} - {{Format.toLocalDateTime(c.toDate, 'MM/DD/YYYY H:mm')}}</span></p>
													</div>
													<div class="collapsible-entry__map-button">
														<b-button class="pl-2 pr-2 pt-0 pb-2" variant="text" type="button" @click="showRequestOnMap(c.id)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
													</div>
												</div>
												<div class="d-flex lcr-conflicts__entry" v-for="c in adjacentStartConflict" v-bind:key="'lcr-adj-start-conflicts-entry-'+c.id+'-'+Math.random()">
													<div class="flex-grow-1">
														<b-link variant="link" @click="viewLaneClosureRequest(c.id)">Adjacent Start Date with LCR: {{c.id}}</b-link>
														<p><span>{{c.affectedStreet}} between {{c.firstCrossStreet}} and {{c.lastCrossStreet}}</span><br />
															<span>{{Format.toLocalDateTime(c.fromDate, 'MM/DD/YYYY H:mm')}} - {{Format.toLocalDateTime(c.toDate, 'MM/DD/YYYY H:mm')}}</span></p>
														<p>We recommend placing a 3 business day gap between the end date of the request in conflict and the start date of your lane closure request. Request may be denied, otherwise.</p>
													</div>
													<div class="collapsible-entry__map-button">
														<b-button class="pl-2 pr-2 pt-0 pb-2" variant="text" type="button" @click="showRequestOnMap(c.id)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
													</div>
												</div>
												<div class="d-flex lcr-conflicts__entry" v-for="c in adjacentEndConflict" v-bind:key="'lcr-adj-end-conflicts-entry-'+c.id+'-'+Math.random()">
													<div class="flex-grow-1">
														<b-link variant="link" @click="viewLaneClosureRequest(c.id)">Adjacent Completion Date with LCR: {{c.id}}</b-link>
														<p>
															<span>{{c.affectedStreet}}</span> between <span>{{c.firstCrossStreet}}</span> and <span>{{c.lastCrossStreet}}</span><br />
															<span>{{Format.toLocalDateTime(c.fromDate, 'MM/DD/YYYY H:mm')}} - {{Format.toLocalDateTime(c.toDate, 'MM/DD/YYYY H:mm')}}</span></p>
														<p>We recommend placing a 3 business day gap between the end date of your request and the start date of the request in conflict. Request may be denied, otherwise.</p>
													</div>
													<div class="collapsible-entry__map-button">
														<b-button class="pl-2 pr-2 pt-0 pb-2" variant="text" type="button" @click="showRequestOnMap(c.id)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
													</div>
												</div>
											</div>
										</b-col>
									</b-collapse>
								</div>
							</b-col>
						</b-row>


						<b-row v-if="laneClosureRequest.changeRequest">
							<b-col>
								<div id="lcr_change_request__listing__block">

									<b-col class="pt-3">
										<b-row>
											<b-col class="collapse-content-wrapper">
									<p><strong>Details on this screen are for the REQUESTED changes that need to be approved by City of Winnipeg.</strong></p>


										</b-col>
									</b-row>
								</b-col>


										<lcr-change-request-listing-block  :batchDetail="laneClosureRequest.changeRequest" :adminView="false" :logs="laneClosureRequest.changeRequest.auditLog" :lcr="laneClosureRequest" :step="'submitter'" :stepText="'Submitter'" @update:logCount="submitterTotal = $event"></lcr-change-request-listing-block>
									<lcr-change-request-listing-block  :batchDetail="laneClosureRequest.changeRequest" :adminView="false" :logs="laneClosureRequest.changeRequest.auditLog" :lcr="laneClosureRequest" :step="'closures'" :stepText="'Closures and Restrictions'" @update:logCount="closuresTotal = $event"></lcr-change-request-listing-block>
											<lcr-change-request-listing-block  :batchDetail="laneClosureRequest.changeRequest" :adminView="false" :logs="laneClosureRequest.changeRequest.auditLog" :lcr="laneClosureRequest" :step="'dcz'" :stepText="'DCZ, Transit, Parking'" @update:logCount="dczTotal = $event"></lcr-change-request-listing-block>
										<lcr-change-request-listing-block  :batchDetail="laneClosureRequest.changeRequest" :adminView="false" :logs="laneClosureRequest.changeRequest.auditLog" :lcr="laneClosureRequest" :step="'permits'" :stepText="'Permit'" @update:logCount="permitsTotal = $event"></lcr-change-request-listing-block>
									</div>



							</b-col>
						</b-row>

						<b-row>
							<b-col>

								<div class="comments__traffic">
									<b-row v-if="canChangeStatus() && laneClosureRequest.internalComments.value">
										<b-col class="mb-2">
											<div class="lcr-summary__section-label">Internal Comments</div>
											<div class="lcr-summary__section-value" v-if="laneClosureRequest.internalComments.value" v-html="laneClosureRequest.internalComments.value"></div>
										</b-col>
									</b-row>
									<b-row>
										<b-col class="mb-2">
											<div class="lcr-summary__section-label">Comments and Explanations</div>
											<div class="lcr-summary__section-value" v-if="laneClosureRequest.requesterComments.value" v-html="laneClosureRequest.requesterComments.value"></div>
											<div class="lcr-summary__section-value" v-else>N/A</div>
										</b-col>
									</b-row>
									<b-row v-show="canSetTrafficEffect">
										<b-col :class="!$store.state.isMobile ? 'mb-3' : ''">
											<div class="lcr-summary__section-label">Traffic Effect for the Public</div>
											<b-form-textarea id="edit-lcr__traffic-effect" rows="4" no-resize v-model="laneClosureRequest.trafficEffect.value" @input="laneClosureRequest.trafficEffect.resetStatus(); unsavedChanges = true;" :state="laneClosureRequest.trafficEffect.status">
											</b-form-textarea>
											<div class="text-right">
												<b-button :disabled="isButtonDisabled" variant="outline-primary" :class="!$store.state.isMobile ? 'mb-3' : ''" class="mt-3" @click="onSetTrafficEffect">Update Traffic Effect <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner>
												</b-button>
											</div>
										</b-col>
									</b-row>
									<b-row v-show="!canSetTrafficEffect && laneClosureRequest.trafficEffect.value != null">
										<b-col>
											<div class="lcr-summary__section-label">Traffic Effect for the Public</div>
											<div class="lcr-summary__section-value" v-html="laneClosureRequest.trafficEffect.value"></div>
										</b-col>
									</b-row>
								</div>
								<b-row v-if="hasAnyLane()">
									<b-col>
										<div class="d-flex">
											<div class="lcr-summary__section-label main-section-label">Closures</div>
										</div>
									</b-col>
								</b-row>
								<b-row v-if="hasAnyLane()">
									<b-col class="mb-2">
										<div class="d-flex lcr--restriction--legend">
											<div class="lcr-summary__status-legend">
												<!-- <span class="status-circle lc-closed"></span> -->
												<img src="/img/assets/set-all-close.svg" alt=""/>
												<span class="status-circle__label">Closed</span>
											</div>
											<div class="lcr-summary__status-legend">
												<!-- <span class="status-circle lc-open"></span> -->
												<img src="/img/assets/set-all-open.svg" alt=""/>
												<span class="status-circle__label"> Open</span>
											</div>
											<div class="lcr-summary__status-legend">
												<!-- <span class="status-circle lc-not-reported"></span> -->
												<img src="/img/assets/not-reported.svg" alt=""/>
												<span class="status-circle__label"> Not Reported</span>
											</div>
										</div>
									</b-col>
								</b-row>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(1)" :canReport="canReportClosure" :expand="expandCustomizeLane['1']" :laneId="1" v-bind:key="'viewlaneListing1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(2)" :canReport="canReportClosure" :expand="expandCustomizeLane['2']" :laneId="2" v-bind:key="'viewlaneListing2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(24)" :canReport="canReportClosure" :expand="expandCustomizeLane['24']" :laneId="24" v-bind:key="'viewlaneListing24-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(25)" :canReport="canReportClosure" :expand="expandCustomizeLane['25']" :laneId="25" v-bind:key="'viewlaneListing25-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(3)" :canReport="canReportClosure" :expand="expandCustomizeLane['3']" :laneId="3" v-bind:key="'viewlaneListing3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(15)" :canReport="canReportClosure" :expand="expandCustomizeLane['15']" :laneId="15" v-bind:key="'viewlaneListing15-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(32)" :canReport="canReportClosure" :expand="expandCustomizeLane['32']" :laneId="32" v-bind:key="'viewlaneListing32-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(33)" :canReport="canReportClosure" :expand="expandCustomizeLane['33']" :laneId="33" v-bind:key="'viewlaneListing33-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(44)" :canReport="canReportClosure" :expand="expandCustomizeLane['44']" :laneId="44" v-bind:key="'viewlaneListing44-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(19)" :canReport="canReportClosure" :expand="expandCustomizeLane['19']" :laneId="19" v-bind:key="'viewlaneListing19-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>

								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(40)" :canReport="canReportClosure" :expand="expandCustomizeLane['40']" :laneId="40" v-bind:key="'viewlaneListing40-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(4)" :canReport="canReportClosure" :expand="expandCustomizeLane['4']" :laneId="4" v-bind:key="'viewlaneListing4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(5)" :canReport="canReportClosure" :expand="expandCustomizeLane['5']" :laneId="5" v-bind:key="'viewlaneListing5-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(26)" :canReport="canReportClosure" :expand="expandCustomizeLane['26']" :laneId="26" v-bind:key="'viewlaneListing26-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(27)" :canReport="canReportClosure" :expand="expandCustomizeLane['27']" :laneId="27" v-bind:key="'viewlaneListing27-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(6)" :canReport="canReportClosure" :expand="expandCustomizeLane['6']" :laneId="6" v-bind:key="'viewlaneListing6-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(16)" :canReport="canReportClosure" :expand="expandCustomizeLane['16']" :laneId="16" v-bind:key="'viewlaneListing16-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(34)" :canReport="canReportClosure" :expand="expandCustomizeLane['34']" :laneId="34" v-bind:key="'viewlaneListing34-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(35)" :canReport="canReportClosure" :expand="expandCustomizeLane['35']" :laneId="35" v-bind:key="'viewlaneListing35-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(20)" :canReport="canReportClosure" :expand="expandCustomizeLane['20']" :laneId="20" v-bind:key="'viewlaneListing20-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(45)" :canReport="canReportClosure" :expand="expandCustomizeLane['45']" :laneId="45" v-bind:key="'viewlaneListing45-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(41)" :canReport="canReportClosure" :expand="expandCustomizeLane['41']" :laneId="41" v-bind:key="'viewlaneListing41-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>

								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(7)" :canReport="canReportClosure" :expand="expandCustomizeLane['7']" :laneId="7" v-bind:key="'viewlaneListing7-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(8)" :canReport="canReportClosure" :expand="expandCustomizeLane['8']" :laneId="8" v-bind:key="'viewlaneListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(28)" :canReport="canReportClosure" :expand="expandCustomizeLane['28']" :laneId="28" v-bind:key="'viewlaneListing28-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(29)" :canReport="canReportClosure" :expand="expandCustomizeLane['29']" :laneId="29" v-bind:key="'viewlaneListing29-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(9)" :canReport="canReportClosure" :expand="expandCustomizeLane['9']" :laneId="9" v-bind:key="'viewlaneListing9-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(17)" :canReport="canReportClosure" :expand="expandCustomizeLane['17']" :laneId="17" v-bind:key="'viewlaneListing17-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(36)" :canReport="canReportClosure" :expand="expandCustomizeLane['36']" :laneId="36" v-bind:key="'viewlaneListing36-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(37)" :canReport="canReportClosure" :expand="expandCustomizeLane['37']" :laneId="37" v-bind:key="'viewlaneListing37-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(21)" :canReport="canReportClosure" :expand="expandCustomizeLane['21']" :laneId="21" v-bind:key="'viewlaneListing21-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(46)" :canReport="canReportClosure" :expand="expandCustomizeLane['46']" :laneId="46" v-bind:key="'viewlaneListing46-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(42)" :canReport="canReportClosure" :expand="expandCustomizeLane['42']" :laneId="42" v-bind:key="'viewlaneListing42-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>

								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(10)" :canReport="canReportClosure" :expand="expandCustomizeLane['10']" :laneId="10" v-bind:key="'viewlaneListing10-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(11)" :canReport="canReportClosure" :expand="expandCustomizeLane['11']" :laneId="11" v-bind:key="'viewlaneListing11-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(30)" :canReport="canReportClosure" :expand="expandCustomizeLane['30']" :laneId="30" v-bind:key="'viewlaneListing30-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(31)" :canReport="canReportClosure" :expand="expandCustomizeLane['31']" :laneId="31" v-bind:key="'viewlaneListing31-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(12)" :canReport="canReportClosure" :expand="expandCustomizeLane['12']" :laneId="12" v-bind:key="'viewlaneListing12-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(22)" :canReport="canReportClosure" :expand="expandCustomizeLane['22']" :laneId="22" v-bind:key="'viewlaneListing22-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(18)" :canReport="canReportClosure" :expand="expandCustomizeLane['18']" :laneId="18" v-bind:key="'viewlaneListing18-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(38)" :canReport="canReportClosure" :expand="expandCustomizeLane['38']" :laneId="38" v-bind:key="'viewlaneListing38-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(39)" :canReport="canReportClosure" :expand="expandCustomizeLane['39']" :laneId="39" v-bind:key="'viewlaneListing39-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(13)" :canReport="canReportClosure" :expand="expandCustomizeLane['13']" :laneId="13" v-bind:key="'viewlaneListing13-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(14)" :canReport="canReportClosure" :expand="expandCustomizeLane['14']" :laneId="14" v-bind:key="'viewlaneListing14-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(23)" :canReport="canReportClosure" :expand="expandCustomizeLane['23']" :laneId="23" v-bind:key="'viewlaneListing23-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(47)" :canReport="canReportClosure" :expand="expandCustomizeLane['47']" :laneId="47" v-bind:key="'viewlaneListing47-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>
								<view-lane-closure-request-block-lane-listing v-if="hasLaneId(43)" :canReport="canReportClosure" :expand="expandCustomizeLane['43']" :laneId="43" v-bind:key="'viewlaneListing43-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueLanes="laneClosureRequest.uniqueLanes"></view-lane-closure-request-block-lane-listing>

								<view-lane-closure-request-block-sidewalk-listing v-if="hasSidewalkId(1)" :canReport="canReportClosure" :expand="expandCustomizeSidewalk['1']" :sidewalkId="1" v-bind:key="'viewsidewalkListing1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-sidewalk-listing>
								<view-lane-closure-request-block-sidewalk-listing v-if="hasSidewalkId(2)" :canReport="canReportClosure" :expand="expandCustomizeSidewalk['2']" :sidewalkId="2" v-bind:key="'viewsidewalkListing2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-sidewalk-listing>
								<view-lane-closure-request-block-sidewalk-listing v-if="hasSidewalkId(3)" :canReport="canReportClosure" :expand="expandCustomizeSidewalk['3']" :sidewalkId="3" v-bind:key="'viewsidewalkListing3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-sidewalk-listing>
								<view-lane-closure-request-block-sidewalk-listing v-if="hasSidewalkId(4)" :canReport="canReportClosure" :expand="expandCustomizeSidewalk['4']" :sidewalkId="4" v-bind:key="'viewsidewalkListing4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-sidewalk-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(1)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['1']" :bicycleLaneId="1" v-bind:key="'viewbicycleListing1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(2)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['2']" :bicycleLaneId="2" v-bind:key="'viewbicycleListing2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(3)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['3']" :bicycleLaneId="3" v-bind:key="'viewbicycleListing3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(4)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['4']" :bicycleLaneId="4" v-bind:key="'viewbicycleListing4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(5)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['5']" :bicycleLaneId="5" v-bind:key="'viewbicycleListing5-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(6)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['6']" :bicycleLaneId="6" v-bind:key="'viewbicycleListing6-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(7)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['7']" :bicycleLaneId="7" v-bind:key="'viewbicycleListing7-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(8)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['8']" :bicycleLaneId="8" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(9)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['9']" :bicycleLaneId="9" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(10)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['10']" :bicycleLaneId="10" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(11)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['11']" :bicycleLaneId="11" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<view-lane-closure-request-block-bicycle-listing v-if="hasBicycleId(12)" :canReport="canReportClosure" :expand="expandCustomizeBicycle['12']" :bicycleLaneId="12" v-bind:key="'viewbicycleListing8-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-bicycle-listing>
								<b-row v-if="hasRestrictions()">
									<b-col class="mb-2">
										<div class="d-flex">
											<div class="lcr-summary__section-label main-section-label">Turning Restrictions</div>
										</div>
										<div class="d-flex lcr--restriction--legend">
											<div class="lcr-summary__status-legend">
												<!-- <span class="status-circle r-in-place"></span> -->
												<img src="/img/assets/set-all-close.svg" alt=""/>
												<span class="status-circle__label">In Place</span>
											</div>
											<div class="lcr-summary__status-legend">
												<!-- <span class="status-circle r-removed"></span> -->
												<img src="/img/assets/set-all-open.svg" alt=""/>
												<span class="status-circle__label">Removed</span>
											</div>
											<div class="lcr-summary__status-legend">
												<!-- <span class="status-circle lc-not-reported"></span> -->
												<img src="/img/assets/not-reported.svg" alt=""/>
												<span class="status-circle__label"> Not Reported</span>
											</div>
										</div>
									</b-col>
								</b-row>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(1,1)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['1,1']" :restrictionTypeId="1" :directionId="1" v-bind:key="'viewrestrictionListing1-1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(1,2)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['1,2']" :restrictionTypeId="1" :directionId="2" v-bind:key="'viewrestrictionListing1-2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(1,3)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['1,3']" :restrictionTypeId="1" :directionId="3" v-bind:key="'viewrestrictionListing1-3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(1,4)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['1,4']" :restrictionTypeId="1" :directionId="4" v-bind:key="'viewrestrictionListing1-4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(2,1)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['2,1']" :restrictionTypeId="2" :directionId="1" v-bind:key="'viewrestrictionListing2-1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(2,2)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['2,2']" :restrictionTypeId="2" :directionId="2" v-bind:key="'viewrestrictionListing2-2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(2,3)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['2,3']" :restrictionTypeId="2" :directionId="3" v-bind:key="'viewrestrictionListing2-3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(2,4)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['2,4']" :restrictionTypeId="2" :directionId="4" v-bind:key="'viewrestrictionListing2-4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(3,1)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['3,1']" :restrictionTypeId="3" :directionId="1" v-bind:key="'viewrestrictionListing3-1-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(3,2)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['3,2']" :restrictionTypeId="3" :directionId="2" v-bind:key="'viewrestrictionListing3-2-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(3,3)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['3,3']" :restrictionTypeId="3" :directionId="3" v-bind:key="'viewrestrictionListing3-3-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<view-lane-closure-request-block-restriction-listing v-if="hasRestrictionTypeId(3,4)"  :canReport="canReportRestriction" :expand="expandCustomizeRestriction['3,4']" :restrictionTypeId="3" :directionId="4" v-bind:key="'viewrestrictionListing3-4-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock" :uniqueRestrictions="laneClosureRequest.uniqueRestrictions"></view-lane-closure-request-block-restriction-listing>
								<b-row>
									<b-col class="mb-2">
										<div class="lcr-summary__section-label main-section-label">More Information</div>
									</b-col>
								</b-row>
								<view-lane-closure-request-block-traffic-signals-altered :expand="expandTrafficSignalsAltered" v-bind:key="'trafficSignalsAlteredListing-'+renderCounter" v-model="laneClosureRequest.block" :preset="laneClosureRequest.presetBlock"></view-lane-closure-request-block-traffic-signals-altered>
								<b-row>
									<b-col>
										<div class="text-primary collapsible collapsed mb-4">
											<div class="collapsible-heading no-click p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title">Total Number of Lanes Closed at Same Time</div>
													<div v-if="laneClosureRequest.lanesClosedSameTime.value" class="w-50 bg-primary-x-light flex-grow-1 collapsible-heading__value">
														{{laneClosureRequest.lanesClosedSameTime.value|uppercase}}
													</div>
													<div v-if="laneClosureRequest.lanesClosedSameTime.value == null" class="w-50 bg-primary-x-light flex-grow-1 collapsible-heading__value">NOT ENTERED</div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>

								<b-row>
									<b-col>
										<div class="text-primary collapsible collapsed mb-4">
											<div class="collapsible-heading no-click p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="flex-grow-1  collapsible-heading__title" v-html="getTempTrafficControl">
													</div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>


								<b-row>
									<b-col>
										<div class="text-primary collapsible collapsed mb-4">
											<div class="collapsible-heading no-click p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="flex-grow-1 bg-secondary-light  collapsible-heading__value collapsible-heading__acaText" v-html="getAcaText">
													</div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
								<b-row v-if="laneClosureRequest.dczRequired.value == 1">
									<b-col>
										<div :class="expandDCZ ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
											<div class="collapsible-heading p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title" @click="onToggleExpandDCZ">Designated Construction Zone (DCZ)</div>
													<div class="w-50 flex-grow-1 bg-primary-x-light collapsible-heading__value" @click="onToggleExpandDCZ">{{getDczRequiredText(laneClosureRequest.dczRequired.value)|uppercase}}</div>
													<div class="bg-primary-x-light collapsible-heading__toggle" v-show="laneClosureRequest.dczRequired.value == 1">
														<b-button href="#" variant="collapsible" :class="expandDCZ ? '' : ' collapsed'" :aria-expanded="expandDCZ ? 'true' : 'false'" aria-controls="collapseDCZ" @click="onToggleExpandDCZ">
															<span class="when-opened">
																<font-awesome-icon icon="chevron-down" />
															</span>
															<span class="when-closed">
																<font-awesome-icon icon="chevron-right" />
															</span>
														</b-button>
													</div>
												</div>
											</div>
											<b-collapse class="collapse--content" id="collapseDCZ" :visible="expandDCZ">
												<b-col>
													<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__label">Construction Limits Change As Work Progresses</div>
													<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__value">{{laneClosureRequest.dczLimits.value||N/A}}</div>
													<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__label">Temporary Traffic Control Removed at end of Each Work Day</div>
													<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__value">{{getYesNoText(laneClosureRequest.dczTemporaryTcRemoved.value)}}</div>
													<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__label">Physical hazards when workers are not present</div>
													<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__value">{{laneClosureRequest.dczHazards.value||N/A}}</div>
													<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__label">Typical hours of work</div>
													<div v-show="laneClosureRequest.dczRequired.value == 1" class="lcr-summary__value">{{laneClosureRequest.dczHoursOfWork.value||N/A}}</div>
												</b-col>
											</b-collapse>
										</div>
									</b-col>
								</b-row>
								<b-row v-if="laneClosureRequest.dczRequired.value != 1">
									<b-col>
										<div class="text-primary collapsible collapsed">
											<div class="collapsible-heading no-click p-0">
												<div class="d-flex block-info-mobile">
													<div class="w-50 collapsible-heading__title">Designated Construction Zone (DCZ)</div>
													<div class="w-50 flex-grow-1 bg-primary-x-light collapsible-heading__value" style="width:100px">{{getDczRequiredText(laneClosureRequest.dczRequired.value)|uppercase}}</div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
								<b-row v-if="laneClosureRequest.transitAffected.value != null">
									<b-col>
										<div :class="expandTransit ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
											<div class="collapsible-heading">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title" v-if="laneClosureRequest.transitAffected.value == 1"  @click="onToggleExpandTransit">Transit</div>
													<div class="w-50 collapsible-heading__title" v-if="laneClosureRequest.transitAffected.value != 1">Transit</div>
													<div v-if="laneClosureRequest.transitAffected.value == 1" class="w-50 collapsible-heading__value bg-primary-x-light flex-grow-1" @click="onToggleExpandTransit">
													<div class="d-flex">
														<div class="flex-grow-1">AFFECTED</div>
														<div class="collapsible-heading__button"><a :href="getBusStopMapLink" class="btn btn-show-map" target="_blank">&nbsp;</a></div>
													</div>
													</div>
													<div v-if="laneClosureRequest.transitAffected.value != 1" class="w-50 collapsible-heading__value bg-secondary-light flex-grow-1">
														<div class="d-flex">
															<div class="flex-grow-1">NOT AFFECTED</div>
															<div class="collapsible-heading__button"><a :href="getBusStopMapLink" class="btn btn-show-map" target="_blank">&nbsp;</a></div>
														</div>
													</div>


													<div class="bg-primary-x-light collapsible-heading__toggle" v-show="laneClosureRequest.transitAffected.value == 1">
														<b-button href="#" variant="collapsible" :class="expandTransit ? '' : ' collapsed'" :aria-expanded="expandTransit ? 'true' : 'false'" aria-controls="collapseTransit" @click="onToggleExpandTransit">
															<span class="when-opened">
																<font-awesome-icon icon="chevron-down" />
															</span>
															<span class="when-closed">
																<font-awesome-icon icon="chevron-right" />
															</span>
														</b-button>
													</div>
												</div>
											</div>
											<b-collapse class="collapse--content" id="collapseTransit" :visible="expandTransit">
												<b-col>
													<div class="lcr-summary__label" v-show="laneClosureRequest.transitAffected.value == 1">Transit Is Affected</div>
													<div class="lcr-summary__label" v-show="laneClosureRequest.transitAffected.value != 1">Transit Not Affected</div>
													<a :href="getBusStopMapLink" class="btn btn-show-map mb-3" target="_blank">Show Map of Bus Stops (opens in new window)</a>
													<div v-for="t in laneClosureRequest.transit.value" v-bind:key="'transit'+t.transitEffectId" class="lcr-summary__value">{{LaneClosureRequest.getTransitText(t.transitEffectId)}}</div>
													<div class="lcr-summary__value">{{laneClosureRequest.transitOther.value}}</div>
													<div class="lcr-summary__label mt-2" v-show="laneClosureRequest.transitAffected.value == 1">Bus Stop Numbers</div>
													<div class="lcr-summary__value" v-show="laneClosureRequest.transitAffected.value == 1">{{laneClosureRequest.transitStopNumbers.value}}</div>
												</b-col>
											</b-collapse>
										</div>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<div class="text-primary collapsible collapsed mb-4">
											<div class="collapsible-heading no-click p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title">Paid Parking</div>
													<div v-if="laneClosureRequest.paidParkingAffected.value == 1" class="w-50 flex-grow-1 bg-primary-x-light  collapsible-heading__value">AFFECTED</div>
													<div v-if="laneClosureRequest.paidParkingAffected.value != 1" class="w-50 flex-grow-1 bg-secondary-light  collapsible-heading__value">NOT AFFECTED</div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<div :class="expandParking ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
											<div class="collapsible-heading p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title" v-if="laneClosureRequest.parkingRemovalId.value != 2" @click="onToggleExpandParking">Parking Removal</div>
													<div class="w-50 collapsible-heading__title" v-if="laneClosureRequest.parkingRemovalId.value == 2">Parking Removal</div>
													<div class="w-50 d-flex collapsible-heading__value">
														<div class="flex-grow-1" v-if="laneClosureRequest.parkingRemovalId.value == 2" v-html="getCustomParkingRemovalText()"></div>
														<div class="flex-grow-1" v-if="laneClosureRequest.parkingRemovalId.value != 2" @click="onToggleExpandParking" v-html="getCustomParkingRemovalText()"></div>
														<div class="collapsible-heading__button"><a :href="getParkingSpotMapLink" class="btn btn-show-map" target="_blank">&nbsp;</a></div>
													</div>
													<div class="bg-primary-x-light collapsible-heading__toggle" v-show="laneClosureRequest.parkingRemovalId.value == 1 || laneClosureRequest.parkingRemovalId.value == 5">
														<b-button href="#" variant="collapsible" :class="expandParking ? '' : ' collapsed'" :aria-expanded="expandParking ? 'true' : 'false'" aria-controls="collapseParking" @click="onToggleExpandParking">
															<span class="when-opened">
																<font-awesome-icon icon="chevron-down" />
															</span>
															<span class="when-closed">
																<font-awesome-icon icon="chevron-right" />
															</span>
														</b-button>
													</div>
												</div>
											</div>
											<b-collapse class="collapse--content" id="collapseParking" :visible="expandParking">
												<!-- <b-col>
													<a :href="getParkingSpotMapLink" class="btn btn-show-map mb-3" target="_blank">Show Map of Parking Spots (opens in new window)</a>

													<div v-if="laneClosureRequest.parkingLane.value.length == 1" class="lcr-summary__label">Removing Parking from Lane</div>
													<div v-if="laneClosureRequest.parkingLane.value.length > 1" class="lcr-summary__label">Removing Parking from Lanes</div>

													<div v-for="(l, index) in laneClosureRequest.parkingLane.value" class="lcr-summary__value" :key="'cc'+index">
														{{getParkingLaneRemovedText(l.laneId)}}
													</div>
													<div class="lcr-summary__label" v-if="laneClosureRequest.parkingRemovalMetres.value">Distance to Remove Parking</div>
													<div class="lcr-summary__value" v-if="laneClosureRequest.parkingRemovalMetres.value">{{laneClosureRequest.parkingRemovalMetres.value}} metres</div>

													<div class="lcr-summary__label" v-if="laneClosureRequest.parkingStartAddress.value">Starting Point for Parking Removal</div>
													<div class="lcr-summary__value">{{laneClosureRequest.parkingStartAddress.value}}</div>

													<div class="lcr-summary__label" v-if="laneClosureRequest.parkingEndAddress.value">Ending Point for Parking Removal</div>
													<div class="lcr-summary__value" v-if="laneClosureRequest.parkingEndAddress.value">{{laneClosureRequest.parkingEndAddress.value}}</div>
												</b-col> -->
												<ViewLaneClosureRequestParkingRemovalListing
													:renderCounter="renderCounter"
													:parkingRemovalList="groupedByParkingLaneId"
												></ViewLaneClosureRequestParkingRemovalListing>

											</b-collapse>
										</div>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<div class="text-primary collapsible collapsed">
											<div class="collapsible-heading no-click p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title">Work Done For</div>
													<div class="w-50 collapsible-heading__value bg-primary-x-light flex-grow-1" v-html="getWorkDoneForText(laneClosureRequest.workDoneForNamePath.value)"></div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<div class="text-primary collapsible collapsed">
											<div class="collapsible-heading no-click p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title">Bid Opportunity Number</div>
													<div class="w-50 collapsible-heading__value bg-primary-x-light flex-grow-1">{{laneClosureRequest.projectBidNumber.value}}</div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<div class="text-primary collapsible collapsed">
											<div class="collapsible-heading no-click p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title">City Administrator</div>
													<div class="w-50 collapsible-heading__value bg-primary-x-light flex-grow-1" v-html="getBidAdmin()"></div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
								<b-row v-show="laneClosureRequest.workDoneForIdPath.isCoWFSEO()">
									<b-col>
										<div class="text-primary collapsible collapsed">
											<div class="collapsible-heading  no-click p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title">City of Winnipeg Film and Special Events Office Identifier</div>
													<div class="w-50 collapsible-heading__value bg-primary-x-light flex-grow-1">{{laneClosureRequest.wfseoControlCode.value}}</div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
								<b-row v-show="laneClosureRequest.workDoneForIdPath.isCoWFSEO()">
									<b-col>
										<div class="text-primary collapsible collapsed">
											<div class="collapsible-heading  no-click p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title">Permit Request Information</div>
													<div class="w-50 collapsible-heading__value bg-primary-x-light flex-grow-1">{{laneClosureRequest.wfseoPermitRequestInfo.value}}</div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<div :class="expandPermit ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
											<div class="collapsible-heading p-0">
												<div class="d-flex bottom-border block-info-mobile">
													<div class="w-50 collapsible-heading__title" @click="onToggleExpandPermit">Permit</div>
													<div @click="onToggleExpandPermit" v-if="laneClosureRequest.permitRequired.value == 1" class="w-50 bg-primary-x-light flex-grow-1 collapsible-heading__value">REQUIRED</div>
													<div @click="onToggleExpandPermit" v-if="laneClosureRequest.permitRequired.value != 1" class="w-50 bg-primary-x-light flex-grow-1 collapsible-heading__value">NOT REQUIRED</div>
													<div class="bg-primary-x-light collapsible-heading__toggle" v-show="laneClosureRequest.permitRequired.value == 1">
														<b-button href="#" variant="collapsible" :class="expandPermit ? '' : 'collapsed'" :aria-expanded="expandPermit ? 'true' : 'false'" aria-controls="collapsePermit" @click="onToggleExpandPermit">
															<span class="when-opened">
																<font-awesome-icon icon="chevron-down" />
															</span>
															<span class="when-closed">
																<font-awesome-icon icon="chevron-right" />
															</span>
														</b-button>
													</div>
												</div>
											</div>
											<b-collapse class="collapse--content" id="collapsePermit" :visible="expandPermit">
												<b-col>
													<b-row v-show="laneClosureRequest.permitRequired.value == 1">
														<b-col class="mb-3">
															<div class="lcr-summary__label">Liability Insurance</div>
															<div class="lcr-summary__value">{{LaneClosureRequest.getYesNoText(laneClosureRequest.permitLiabilityInsurance.value)}}</div>
														</b-col>
													</b-row>
													<b-row v-show="laneClosureRequest.permitRequired.value == 1 && 1 == 2">
														<b-col class="mb-3">
															<div class="lcr-summary__label">Nearest Street Number TO Affected Closure Area</div>
															<div class="lcr-summary__value">{{laneClosureRequest.permitNearestStreetNumber.value}}</div>
														</b-col>
													</b-row>
													<b-row v-show="laneClosureRequest.permitRequired.value == 1">
														<b-col class="mb-3">
															<div class="lcr-summary__label">Total length of affected ROADWAY</div>
															<div class="lcr-summary__value">{{laneClosureRequest.permitRoadwayMetres.value}} metres</div>
														</b-col>
													</b-row>
													<b-row v-show="laneClosureRequest.permitRequired.value == 1">
														<b-col class="mb-3">
															<div class="lcr-summary__value">Measured From: {{laneClosureRequest.permitRoadwayFrom.value}}</div>
															<div class="lcr-summary__value">Measured To: {{laneClosureRequest.permitRoadwayTo.value}}</div>
														</b-col>
													</b-row>
													<b-row v-show="laneClosureRequest.permitRequired.value == 1">
														<b-col class="mb-3">
															<div class="lcr-summary__label">SIDEWALK</div>
															<div class="lcr-summary__value">Measured From: {{laneClosureRequest.permitSidewalkFrom.value}}</div>
															<div class="lcr-summary__value">Measured To: {{laneClosureRequest.permitSidewalkTo.value}}</div>
															<div class="lcr-summary__value">Length: {{laneClosureRequest.permitSidewalkMetres.value}} m</div>
														</b-col>
													</b-row>
													<b-row v-show="laneClosureRequest.permitRequired.value == 1 && laneClosureRequest.permitRequests.value">
														<b-col class="mb-3">
															<div class="lcr-summary__label">Additional Relevant Information Provided</div>
															<div class="lcr-summary__value">{{laneClosureRequest.permitRequests.value}}</div>
														</b-col>
													</b-row>
													<b-row v-show="laneClosureRequest.permitRequired.value == 1">
														<b-col class="mb-3">
															<div class="lcr-summary__label" v-show="laneClosureRequest.crossingPermitRequired.value == 1">Crossing Permit Required</div>
															<div class="lcr-summary__label" v-show="laneClosureRequest.crossingPermitRequired.value != 1">No Crossing Permit Required</div>
														</b-col>
													</b-row>
													<b-row v-show="laneClosureRequest.crossingPermitRequired.value == 1">
														<b-col class="mb-3">
															<div class="lcr-summary__label">Crossing the sidewalk / boulevard / curb Area</div>
															<div class="lcr-summary__value">{{laneClosureRequest.crossingPermitLocation.value}}</div>
														</b-col>
													</b-row>
													<b-row v-show="laneClosureRequest.crossingPermitRequired.value == 1">
														<b-col class="mb-3">
															<div class="lcr-summary__label">Type of Equipment used while crossing the area</div>
															<div class="lcr-summary__value">{{laneClosureRequest.crossingPermitEquipment.value}}</div>
														</b-col>
													</b-row>
												</b-col>
											</b-collapse>
										</div>
									</b-col>
								</b-row>
							</b-col>
						</b-row>

						<b-row v-if="canChangeStatus() && !laneClosureRequest.changeRequest" class="bg-secondary-light pt-3 lcr-detail-data-mobile">
							<b-col lg="auto">
								<div class="lcr-summary__label mb-2">Approval Status</div>
								<div class="lcr-summary__value mb-3">
									<b-form-select v-model="laneClosureRequest.approvalStatusId.value" :options="LaneClosureRequest.getApprovalStatusIdOptions" @input="laneClosureRequest.approvalStatusId.resetStatus(); unsavedChanges = true;" @change="approvalStatusChanged" :state="laneClosureRequest.approvalStatusId.status" value-field="id" text-field="name"></b-form-select>
								</div>
								<div class="lcr-summary__label mb-2">Record Status</div>
								<div class="lcr-summary__value mb-3" v-if="canChangeStatus()">
									<b-form-select v-model="laneClosureRequest.recordStatusId.value" :options="LaneClosureRequest.getLaneClosureRequestRecordStatusIdOptions" @input="laneClosureRequest.recordStatusId.resetStatus();unsavedChanges = true;" @change="recordStatusChanged" :state="laneClosureRequest.recordStatusId.status" value-field="id" text-field="name"></b-form-select>
								</div>
								<div class="lcr-summary__label" v-show="laneClosureRequest.recordStatusId.value == 7">Completion Status</div>
								<div class="lcr-summary__value mb-3" v-show="laneClosureRequest.recordStatusId.value == 7">
									<b-form-select v-model="laneClosureRequest.completeTypeId.value" :options="LaneClosureRequest.getCompleteTypeIdOptions" @input="laneClosureRequest.completeTypeId.resetStatus();unsavedChanges = true;" :state="laneClosureRequest.completeTypeId.status" value-field="id" text-field="name"></b-form-select>
								</div>
							</b-col>
							<b-col>
								<b-form-group id="ig-primary-contact" label="Public Website" label-for="input-lcr-primary-contact" description="">
								<b-form-checkbox :checked="laneClosureRequest.displayTime.value == 1" v-model="laneClosureRequest.displayTime.value" key="displayTime" :unchecked-value="0" :value="1" name="displayTime" @input="unsavedChanges = true;"><span>Display Time</span></b-form-checkbox>
							</b-form-group>

								<b-form-group id="ig-primary-contact" label="Approver" label-for="input-lcr-primary-contact" description="">
									<div v-if="laneClosureRequest.owner" class="contact">
										<div class="contact__name">{{laneClosureRequest.owner.firstName}} {{laneClosureRequest.owner.lastName}}</div>
										<div class="contact__organization">{{laneClosureRequest.owner.organizationName}}</div>
										<div class="contact__phone">{{laneClosureRequest.owner.phone}}</div>
									</div>
									<autocomplete data-position="above" :search="onOwnerSearch" @submit="onOwnerSelect" placeholder="Start typing to select Approver" aria-label="Start typing to select Approver" ref="searchOwner" auto-select>
										<template v-slot:result=" {result, props } ">
											<li v-bind="props" class="autocomplete-result primary-contact-result">
												<div class="contact-name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
												<div class="contact-organization">{{result.organizationName}}</div>
												<div class="contact-phone">{{result.phone}}</div>
											</li>
										</template>
									</autocomplete>
								</b-form-group>
								<b-form-group id="ig-last-cross" :label="projectLabel" label-for="input-requester-project-limited" :state="laneClosureRequest.ownerProjectId.status" :invalid-feedback="laneClosureRequest.ownerProjectId.invalidMessage">
									<p>You can create or assign a project to this lane closure request.</p>
									<b-input-group>
										<b-form-select id="input-requester-project-limited" v-model="laneClosureRequest.ownerProjectId.value" @input="projectSelectChanged" :state="laneClosureRequest.ownerProjectId.status" :options="ownerProjectIdOptions" value-field="id" text-field="displayName" inline></b-form-select>
										<b-input-group-append>
											<b-button inline variant="primary" type="button" class="btn-sm" @click="openEditProjectModal()" v-if="laneClosureRequest.ownerProjectId.value > 0">Edit</b-button>
											<b-button inline variant="primary" type="button" class="btn-sm" @click="openNewProjectModal()" v-else>
												<font-awesome-icon icon="plus-circle" />
											</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
								<b-form-group id="ig-primary-contact" label="Include Message If Necessary" label-for="input-lcr-primary-contact" description="">
									<wysiwyg v-model="statusMessage" @input="unsavedChanges = true"/>
								</b-form-group>
								<b-form-group id="ig-internal-comments" label="Internal Comments" label-for="input-lcr-internal-comments" description="" v-if="canChangeInternalComments()">
									<wysiwyg v-model="laneClosureRequest.internalComments.value" @input="unsavedChanges = true"/>
								</b-form-group>
							</b-col>
							<b-col lg="auto" class="text-right">
								<b-button :disabled="isButtonDisabled" variant="primary" @click="onSetStatus" class="mb-2">Apply Changes <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner>
								</b-button>
							</b-col>
						</b-row>

						<!-- can approve, and has change request, so let's adjust status of change request! -->
						<b-row v-if="canChangeStatus() && laneClosureRequest.changeRequest != null" class="bg-secondary-light pt-3 lcr-detail-data-mobile">
							<b-col lg="12">
								<h2>Update Status for Requested Changes #{{laneClosureRequest.changeRequest.id}}</h2>
							</b-col>
							<b-col lg="auto">
								<div class="lcr-summary__label mb-2">Requested Changes<br/>Approval Status</div>
								<div class="lcr-summary__value mb-3">
									<b-form-select v-model="laneClosureRequest.changeRequest.approvalStatusId" :options="LaneClosureRequest.getApprovalStatusIdOptionsForChangeRequest" @input="unsavedChanges = true;" @change="changeRequestApprovalStatusChanged" value-field="id" text-field="name"></b-form-select>
								</div>
								<div class="lcr-summary__label mb-2">Requested Changes<br/>Record Status</div>
								<div class="lcr-summary__value mb-3" v-if="canChangeStatus()">
									<b-form-select v-model="laneClosureRequest.changeRequest.recordStatusId" :options="LaneClosureRequest.getLaneClosureRequestRecordStatusIdOptionsForChangeRequest" @input="unsavedChanges = true;" @change="changeRequestRecordStatusChanged" value-field="id" text-field="name"></b-form-select>
								</div>
								<div class="lcr-summary__label" v-show="laneClosureRequest.changeRequest.recordStatusId == 7">Requested Changes<br/>Completion Status</div>
								<div class="lcr-summary__value mb-3" v-show="laneClosureRequest.changeRequest.recordStatusId == 7">
									<b-form-select v-model="laneClosureRequest.changeRequest.completeTypeId" :options="LaneClosureRequest.getCompleteTypeIdOptionsForChangeRequest" @input="unsavedChanges = true;" value-field="id" text-field="name"></b-form-select>
								</div>
							</b-col>
							<b-col>
								<b-form-group id="ig-primary-contact" label="Public Website" label-for="input-lcr-primary-contact" description="">
								<b-form-checkbox :checked="laneClosureRequest.displayTime.value == 1" v-model="laneClosureRequest.displayTime.value" key="displayTime" :unchecked-value="0" :value="1" name="displayTime" @input="unsavedChanges = true;"><span>Display Time</span></b-form-checkbox>
							</b-form-group>

								<b-form-group id="ig-primary-contact" label="Approver" label-for="input-lcr-primary-contact" description="">
									<div v-if="laneClosureRequest.owner" class="contact">
										<div class="contact__name">{{laneClosureRequest.owner.firstName}} {{laneClosureRequest.owner.lastName}}</div>
										<div class="contact__organization">{{laneClosureRequest.owner.organizationName}}</div>
										<div class="contact__phone">{{laneClosureRequest.owner.phone}}</div>
									</div>
									<autocomplete data-position="above" :search="onOwnerSearch" @submit="onOwnerSelect" placeholder="Start typing to select Approver" aria-label="Start typing to select Approver" ref="searchOwner" auto-select>
										<template v-slot:result=" {result, props } ">
											<li v-bind="props" class="autocomplete-result primary-contact-result">
												<div class="contact-name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
												<div class="contact-organization">{{result.organizationName}}</div>
												<div class="contact-phone">{{result.phone}}</div>
											</li>
										</template>
									</autocomplete>
								</b-form-group>
								<b-form-group id="ig-last-cross" :label="projectLabel" label-for="input-requester-project-limited" :state="laneClosureRequest.ownerProjectId.status" :invalid-feedback="laneClosureRequest.ownerProjectId.invalidMessage">
									<p>You can create or assign a project to this lane closure request.</p>
									<b-input-group>
										<b-form-select id="input-requester-project-limited" v-model="laneClosureRequest.ownerProjectId.value" @input="projectSelectChanged" :state="laneClosureRequest.ownerProjectId.status" :options="ownerProjectIdOptions" value-field="id" text-field="displayName" inline></b-form-select>
										<b-input-group-append>
											<b-button inline variant="primary" type="button" class="btn-sm" @click="openEditProjectModal()" v-if="laneClosureRequest.ownerProjectId.value > 0">Edit</b-button>
											<b-button inline variant="primary" type="button" class="btn-sm" @click="openNewProjectModal()" v-else>
												<font-awesome-icon icon="plus-circle" />
											</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
								<b-form-group id="ig-primary-contact" label="Include Message If Necessary" label-for="input-lcr-primary-contact" description="">
									<wysiwyg v-model="statusMessage" @input="unsavedChanges = true"/>
								</b-form-group>
								<b-form-group id="ig-internal-comments" label="Internal Comments" label-for="input-lcr-internal-comments" description="" v-if="canChangeInternalComments()">
									<wysiwyg v-model="laneClosureRequest.internalComments.value" @input="unsavedChanges = true"/>
								</b-form-group>
							</b-col>
							<b-col lg="auto" class="text-right">
								<b-button :disabled="isButtonDisabled" variant="primary" @click="onSetStatusChangeRequest" class="mb-2">Apply Changes <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner>
								</b-button>
							</b-col>
						</b-row>

					</b-col>




					<b-col v-if="!$store.state.isMobile" lg="5" class="lcr-summary__right-column">
						<div class="lcr-summary__section-label mt-3">Communication</div>
						<h2>Messages</h2>
						<lane-closure-request-chat v-model="laneClosureRequest.message" :laneClosureRequestId="laneClosureRequest.id" ref="newMessage" :busy="sendingMessage"></lane-closure-request-chat>
						<div v-if="auditBatches.length > 0" class="lcr-summary__section-label" id="updatesList">Activity</div>
						<template>
							<lane-closure-updates-listing v-for="(log, i) in auditBatches" :batchDetail="{user: log.userName, notes: log.batchNotes, time: Format.toLocalDateTime(log.batchDate, 'MM/DD/YYYY HH:mm:ss'), auditTypeId: log.auditTypeId,
						organizationName: log.organizationName, organizationType: log.organizationType}" :logs="log.auditLog" :lcr="laneClosureRequest" :key="'log-'+i+'-'+renderCounter" />
						</template>
						<div class="text-center" v-if="auditBatchCount > auditBatches.length">
							<b-button type="button" variant="light-blue" @click="onViewUpdates">View All Activities <b-spinner small label="Loading..." class="ml-2" v-if="loadingUpdates"></b-spinner>
							</b-button>
						</div>
						<div class="text-center" v-if="auditBatchCount == auditBatches.length && auditBatchCount > 3">
							<b-button type="button" variant="light-blue" @click="onViewRecent">View Latest 3 <b-spinner small label="Loading..." class="ml-2" v-if="loadingUpdates"></b-spinner>
							</b-button>
						</div>
						<b-row class="row-lcr-summary pt-2 pb-2">
							<b-col>
								<div class="lcr-summary__label">Requester</div>
								<div class="lcr-summary__value">
									<div v-if="laneClosureRequest.requester" class="contact">
										<div class="contact__name"><a :href="emailHref(laneClosureRequest.requester.email)">{{laneClosureRequest.requester.firstName}} {{laneClosureRequest.requester.lastName}}</a></div>
										<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.requester)">
											<div class="contact__organization" :key="i">{{org}}</div>
										</template>
										<div v-show="laneClosureRequest.requester.phone" class="contact__phone">{{laneClosureRequest.requester.phone}}</div>
									</div>
									<div v-for="contact in laneClosureRequest.altRequester" v-bind:key="'c'+contact.userId" class="contact">
										<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
										<template v-for="(org, i) in getOrganizationTreeList(contact)">
											<div class="contact__organization" :key="i">{{org}}</div>
										</template>
										<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
									</div>
								</div>
							</b-col>
							<b-col>
								<div class="lcr-summary__label">Approver</div>
								<div class="lcr-summary__value">
									<div v-if="laneClosureRequest.owner" class="contact">
										<div class="contact__name"><a :href="emailHref(laneClosureRequest.owner.email)">{{laneClosureRequest.owner.firstName}} {{laneClosureRequest.owner.lastName}}</a></div>
										<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.owner)">
											<div class="contact__organization" :key="i">{{org}}</div>
										</template>
										<div v-show="laneClosureRequest.owner.phone" class="contact__phone">{{laneClosureRequest.owner.phone}}</div>
									</div>
									<div v-else>N/A</div>
								</div>
							</b-col>
						</b-row>
						<b-row class="row-lcr-summary pb-2 pt-2">
							<b-col class="">
								<div class="lcr-summary__label">Closure Reporter</div>
								<div class="lcr-summary__value">
									<div v-if="laneClosureRequest.closureReporter" class="contact">
										<div class="contact__name"><a :href="emailHref(laneClosureRequest.closureReporter.email)">{{laneClosureRequest.closureReporter.firstName}} {{laneClosureRequest.closureReporter.lastName}}</a></div>
										<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.closureReporter)">
											<div class="contact__organization" :key="i">{{org}}</div>
										</template>
										<div v-show="laneClosureRequest.closureReporter.phone" class="contact__phone">{{laneClosureRequest.closureReporter.phone}}</div>
									</div>
									<div v-else>
										N/A
									</div>
									<div v-for="contact in laneClosureRequest.altClosureReporter" v-bind:key="'c'+contact.userId" class="contact">
										<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
										<template v-for="(org, i) in getOrganizationTreeList(contact)">
											<div class="contact__organization" :key="i">{{org}}</div>
										</template>
										<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
									</div>
								</div>
							</b-col>
							<b-col>
								<div class="lcr-summary__label">Restrictions Reporter</div>
								<div class="lcr-summary__value">
									<div v-if="laneClosureRequest.restrictionReporter" class="contact">
										<div class="contact__name"><a :href="emailHref(laneClosureRequest.restrictionReporter.email)">{{laneClosureRequest.restrictionReporter.firstName}} {{laneClosureRequest.restrictionReporter.lastName}}</a></div>
										<template v-for="(org, i) in getOrganizationTreeList(laneClosureRequest.restrictionReporter)">
											<div class="contact__organization" :key="i">{{org}}</div>
										</template>
										<div v-show="laneClosureRequest.restrictionReporter.phone" class="contact__phone">{{laneClosureRequest.restrictionReporter.phone}}</div>
									</div>
									<div v-else>
										N/A
									</div>
									<div v-for="contact in laneClosureRequest.altRestrictionReporter" v-bind:key="'c'+contact.userId" class="contact">
										<div class="contact__name"><a :href="emailHref(contact.email)">{{contact.firstName}} {{contact.lastName}}</a></div>
										<template v-for="(org, i) in getOrganizationTreeList(contact)">
											<div class="contact__organization" :key="i">{{org}}</div>
										</template>
										<div v-show="contact.phone" class="contact__phone">{{contact.phone}}</div>
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<div class="lcr-summary__label" v-show="canChangeStatus() || laneClosureRequest.contact.length > 0">Additional Contacts</div>
								<b-form-group id="ig-additional-contacts" description="">
									<div v-if="laneClosureRequest.contact.length > 0" class="contact-container">
										<b-form-row v-for=" (contact, index) in laneClosureRequest.contact" class="contact" v-bind:key="'ccr'+contact.userId+'_'+index">
											<b-col cols="8">
												<div class="contact__name">{{contact.firstName}} {{contact.lastName}}</div>
												<template v-for="(org, i) in getOrganizationTreeList(contact)">
													<div class="contact__organization" :key="i">{{org}}</div>
												</template>
												<div class="contact__phone">{{contact.phone}}</div>
											</b-col>
											<b-col cols="4" class="text-right " v-show="canRemoveContact(contact)">
												<b-button :disabled="isButtonDisabled" variant="light-blue" type="button" class="btn-sm" @click="onRemoveContact(index)">Remove</b-button>
											</b-col>
										</b-form-row>
									</div>
									<div v-show="canAddContact">
										<autocomplete data-position="above" :get-result-value="getContactResult" :search="onContactSearch" @submit="onContactSelect" @keydown="onContactKeydown" placeholder="Start typing to add contacts" aria-label="Start typing to add contacts" ref="searchContact" auto-select>
											<template v-slot:result=" {result, props } ">
												<li v-bind="props" class="autocomplete-result alternate-contact-result">
													<div class="autocomplete__name">{{result.firstName}} {{result.lastName}} {{result.isActive ? '' : '(inactive)'}}</div>
													<template v-for="(org, i) in getOrganizationTreeList(result)">
														<div v-if="org" :key="i" class="autocomplete__organization">{{org}}</div>
													</template>
													<div v-if="result.phone" class="autocomplete__phone">{{result.phone}}</div>
												</li>
											</template>
										</autocomplete>
									</div>
								</b-form-group>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
				<b-modal centered id="new-project-modal" title="Create New Project" size="lg" v-model="showNewProjectModal" ok-title="Create Project" cancel-title="Cancel" @ok="showNewProjectModalOkClick()">
					<b-form-group label="New Project Name">
						<b-form-input id="input-new-project-name" v-model="newProject.name.value" placeholder="Other" :state="newProject.name.status" @input="newProject.name.resetStatus()" inline></b-form-input>
					</b-form-group>
				</b-modal>
				<b-modal centered id="edit-project-modal" title="Rename Project" size="lg" v-model="showEditProjectModal" ok-title="Rename Project" cancel-title="Cancel" @ok="showEditProjectModalOkClick()">
					<b-form-group label="Project Name">
						<b-form-input id="input-edit-project-name" v-model="editProject.name.value" placeholder="Other" :state="editProject.name.status" @input="editProject.name.resetStatus()" inline></b-form-input>
					</b-form-group>
					<template v-slot:modal-footer="footerScope">
						<b-button variant="light" @click="RestoreProject" v-if="editProject != null && editProject.isActive.value == 0">Restore</b-button>
						<b-button variant="light" @click="ArchiveProject" v-else>Archive</b-button>
						<b-button variant="secondary" @click="footerScope.cancel">Cancel</b-button>
						<b-button variant="primary" @click="footerScope.ok">Rename Project</b-button>
					</template>
				</b-modal>
				<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
					<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
					<ul>
						<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'req'+requiredField">{{$t(requiredField)}}</li>
					</ul>
					<template slot="footer">
						<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
					</template>
				</b-modal>


				<b-modal centered v-model="showDiscardChangesModal" type="info" @ok="onDiscardChanges" ok-title="Yes, Discard Requested Changes" cancel-title="No">
					<template v-slot:modal-title>Confirm Discard of Changes</template>
					<p>Are you sure you want to discard the changes you have requested for this lane closure?</p>
				</b-modal>

				<b-modal centered v-model="showCompletedModal" type="info" @ok="onCompleteRequest" ok-title="Yes, Complete Request" cancel-title="No">
					<template v-slot:modal-title>Confirm Completion</template>
					<p>Ensure that all lanes are open and restrctions are removed before completing this lane closure request.</p>
					<p>Do you want to set this request to completed?</p>
					<p>Completing will automatically report any closures as re-opened and restrictions as removed.</p>
				</b-modal>
				<b-modal centered v-model="showCancelModal" type="info" @ok="onCancelRequest" ok-title="Yes, Cancel Request" cancel-title="No">
					<template v-slot:modal-title>Confirm Cancellation of Request</template>
					<p>Are you sure you want to cancel this request?</p>
				</b-modal>
			</b-form>
			<b-modal centered v-model="showRemoveContactModal" type="info" @ok="onConfirmRemoveContact" ok-title="Yes, Remove Contact" cancel-title="No">
				<template v-slot:modal-title>Confirm Removal</template>
				<p>Do you want to remove this contact?</p>

				<p v-show="isRemovingSelf">
					<strong>WARNING:</strong> You are removing yourself from this request.
				</p>
			</b-modal>
			<b-modal centered v-model="showLoadErrorModal" type="info" @ok="onCloseLoadErrorModal" ok-only>
				<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
				<ul>
					<li>{{errorDetails.error.message}}</li>
					<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'req'+requiredField">{{$t(requiredField)}}</li>
				</ul>
			</b-modal>
			<b-modal centered v-model="showLaneClosureRequestUpdated" type="info" @ok="refreshLCR" ok-only>
				<template v-slot:modal-title>{{$t('titles.lcrUpdated')}}</template>
				<p>{{$t('messages.lcrUpdated')}}</p>
			</b-modal>
			<!-- leaving page -->
			<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
				<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
				<template v-slot:modal-footer="{ ok }">
					<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
					<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
					<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
				</template>
			</b-modal>
			<warning-modal ref="warningModal" @action-confirmed="onDuplicateRequest">
				<p>You are duplicating ALL information from this previous request into a new request.</p>
				<p>Please review the duplicated information on each tab to ensure it is correct and applicable to the NEW request.</p>
			</warning-modal>
		</b-container>
		<Spinner v-else />
	</div>
</template>
<script>
// import CloneDeep from 'lodash.clonedeep';
import LaneClosureRequest from '../../models/LaneClosureRequest';
import LaneClosureRequestBlock from '../../models/LaneClosureRequestBlock';
import LaneClosureRequestListEntry from '../../models/LaneClosureRequestListEntry';
import LcrChangeRequestListingBlock from '../../components/LcrChangeRequestListingBlockInView';



// import Datepicker from 'vuejs-datepicker';
import BootstrapField from '../../utility/BootstrapField';
import Autocomplete from '@trevoreyre/autocomplete-vue'

import Format from '../../utility/Format';
import moment from 'moment-timezone'

import ErrorHandler from '../../utility/ErrorHandler';
import { gmapApi } from 'gmap-vue'
import KMLHelper from '../../utility/KMLHelper';

import LaneClosureRequestChat from '../../components/LaneClosureRequestChat';
import LaneClosureRequestMessage from '../../models/LaneClosureRequestMessage';
import LaneClosureViewInfo from '../../components/RequestedChangesViewInfo.vue';
import LaneClosureRequestQuickNav from '../../components/LaneClosureRequestQuickNav.vue';
import LaneClosureRequestQuickNavMobile from '../../components/LaneClosureRequestQuickNavMobile.vue';
import ViewLaneClosureRequestBlockLaneListing from '../../components/ViewLaneClosureRequestBlockLaneListing';
import ViewLaneClosureRequestBlockSidewalkListing from '../../components/ViewLaneClosureRequestBlockSidewalkListing';
import ViewLaneClosureRequestBlockBicycleListing from '../../components/ViewLaneClosureRequestBlockBicycleListing';
import ViewLaneClosureRequestBlockRestrictionListing from '../../components/ViewLaneClosureRequestBlockRestrictionListing';
import ViewLaneClosureRequestBlockTrafficSignalsAltered from '../../components/ViewLaneClosureRequestBlockTrafficSignalsAltered';
import ViewLaneClosureRequestParkingRemovalListing from '../../components/ViewLaneClosureRequestParkingRemovalListing';
import LaneClosureUpdatesListing from '../../components/LaneClosureUpdatesListing.vue';

import WarningModal from './../../components/WarningModal.vue';
import Spinner from "./../../components/Spinner.vue";

import Vue from 'vue'
export default {
	name: 'ViewLaneClosureRequest',
	docTitle() {
		return `Request ${this.id} - Lane Closures`;
	},

	components: {
		LaneClosureRequestChat,
		LaneClosureViewInfo,
		Autocomplete,
		LaneClosureRequestQuickNav,
		LaneClosureRequestQuickNavMobile,
		ViewLaneClosureRequestBlockLaneListing,
		ViewLaneClosureRequestBlockSidewalkListing,
		ViewLaneClosureRequestBlockRestrictionListing,
		ViewLaneClosureRequestBlockBicycleListing,
		ViewLaneClosureRequestBlockTrafficSignalsAltered,
		ViewLaneClosureRequestParkingRemovalListing,
		Spinner,
		LaneClosureUpdatesListing,
		WarningModal,
		LcrChangeRequestListingBlock,
	},
	props: ['id', 'scrollToRef'],
	data() {
		return {
			Format,
			allStreetOptions: [],
			altClosureReporterInfo: [],
			altRequesterInfo: [],
			altRestrictionReporterInfo: [],
			auditBatches: [],
			blockClosuresRestrictionsKey: "blockClosuresRestrictionsKey-0",
			blockDetailsKey: "blockDetailsKey-0",
			blockEditDetailsKey: "blockEditDetailsKey-0",
			blockEditDetailsKeyCounter: 0,
			settingToUnderReview: false,
			closureReporterInfo: null,
			currentMidx: null,
			editingBlockIndex: -1,
			enablePerIntersectionRestriction: new BootstrapField({
				value: null,
				invalidMessage: 'Please indicate if you wish to adjust per intersection restriction',
			}),

			enableDczRequired: new BootstrapField({
				value: null
			}),
			errorDetails: {
				error: {
					details: null
				}
			},
			expandAffectedStreet: false,
			expandBicycle: false,
			expandConflicts: false,
			expandCustomizeBicycle: [],
			expandCustomizeLane: [],
			expandCustomizeRestriction: [],
			expandCustomizeSidewalk: [],
			expandDCZ: false,
			expandParking: false,
			expandPermit: false,
			expandTrafficSignalsAltered: false,
			expandTransit: false,
			firstCoords: null,
			firstCrossStreetMarker: null,
			firstCrossStreetOptions: [],
			googleExists: false,
			googleSearch: null,
			infoContent: '',
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -35
				},
				loaded: null,
			},
			infoWindow: null,
			infoWindowPos: {
				lat: 0,
				lng: 0
			},
			infoWinOpen: false,
			isButtonDisabled: false,
			LaneClosureRequest,
			laneClosureRequest: null,
			lastCoords: null,
			lastCrossStreetMarker: null,
			lastCrossStreetOptions: [],
			lessThanTwoHourModalp1: '',
			lessThanTwoHourModalp2: '',
			lineIndexError: null,
			loaded: false,
			loadError: false,
			loadingUpdates: false,
			mapAffectedGroup: null,
			mapTracks: [],
			map: null,
			markers: [],
			modalRequiredFieldList: [],
			newProject: {
				name: new BootstrapField({
					value: null
				}),
				isActive: new BootstrapField({
					value: true
				}),
				comments: new BootstrapField({
					value: null
				})
			},
			editProject: {
				id: null,
				name: new BootstrapField({
					value: null
				}),
				isActive: new BootstrapField({
					value: true
				}),
				comments: new BootstrapField({
					value: null
				})
			},
			showEditProjectModal: false,

			newRestriction: {
				blockId: new BootstrapField({
					value: null,
				}),
				laneId: new BootstrapField({
					value: null,
				}),
				restrictionTypeId: new BootstrapField({
					value: 1,
				}),
				affectedStreet: new BootstrapField({
					value: null,
				}),
				crossStreet: new BootstrapField({
					value: null,
				})
			},
			noFirstCrossStreetOptions: [{
				text: 'Select Affected Street',
				value: null
			}],
			noLastCrossStreetOptions: [{
				text: 'Select First Cross Street',
				value: null
			}],
			nonRegionalBlock: null,
			onSubmitPromiseDeferred: {
				resolve: null,
				reject: null
			},
			organizationOptions: [],
			organizations: [],
			organizationUserOptions: [],
			ownerProjectIdOptions: [],
			ownerProjectInfo: null, // have to save the project information, in case they change the user, the project will be gone.
			presetBackup: {},
			projectLabel: "Approver's Project",
			removeContactIndex: null,
			renderCounter: 0,
			refSearchRequester: null,
			requesterInfo: null,
			restrictionReporterInfo: null,
			savedChanges: false,
			saveState: null,
			saving: false,
			savingProjects:false,
			sendingMessage: false,
			searchPlace: "2071 Portage Av, Winnipeg MB",
			selectAlternateContact: new BootstrapField({
				value: null,
			}),
			selectAltRestrictionReporter: new BootstrapField({
				value: null,
			}),

			selectRestrictionReporter: new BootstrapField({
				value: null,
			}),
			selectRequester: new BootstrapField({
				value: null,
			}),
			show: true,
			showCancelModal: false,
			showCompletedModal: false,
			showDiscardChangesModal: false,
			showRemoveContactModal: false,
			showLessThanTwoHourModal: false,
			showLoadErrorModal: false,
			showNewProjectModal: false,
			showRequiredFieldModal: false,
			showSpeedReduction: new BootstrapField({
				value: null
			}),
			showUnsavedChangesModal: false,
			unsavedChanges:false,
			statusMessage: null,
			// internalComments: null,
			submissionStatus: null,
			submitted: null,
			vm: {
				searchPlace: '',
				location: {}
			},
			hideMap: false,
			currentBlockOnMap: null,
			cancelSaving: false,
			completeSaving: false,
			showLaneClosureRequestUpdated: false,
		}
	},
	created() {
		this.collapseAll();


		// clear the event bus to prevent multiple hits
		this.$gmapApiPromiseLazy().then(() => {
			this.googleExists = true;
			this.setEventBusOn();
			this.LoadLaneClosureRequest(this.$route.params.id);
			// this.LoadLaneClosureRequest();
			// if (this.$store.getters.userHasRole('internal_admin_requests')) {
				// Vue.prototype.$bus.$emit("map:loadNearby", 1);
			// } else {
				// this.LoadLaneClosureRequest(this.$route.params.id);
			// }
		});

	},
	mounted() {
		// TODO: verify their permissions for this lane closure request.
		// this.getPermission();
		// this.setEventBusOn();
		//this.LoadLaneClosureRequest();
		this.collapseAll();


		this.$nextTick(() => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			this.hideMap = Vue.prototype.$mapShown;
		})

		document.getElementById("main").scrollTo(0, 0);
	},
	computed: {
		companyColor() {
			if (this.laneClosureRequest.changeRequest.organizationType == "city") {
				return "flex-grow-1 bg-primary-x-light collapsible-heading__value color-column";
			} else {
				return "flex-grow-1 bg-secondary-light collapsible-heading__value color-column";
			}
		},
		companyColorDropdownIcon() {
			if (this.laneClosureRequest.changeRequest.organizationType == "city") {
				return "bg-primary-x-light collapsible-heading__toggle";
			} else {
				return "bg-secondary-light collapsible-heading__toggle";
			}
		},
		companyTree() {
			if (this.laneClosureRequest.changeRequest.organizationNamePath) {
				let path = this.laneClosureRequest.changeRequest.organizationNamePath;
				path = path.split('|');
				path.pop();
				path.shift();
				return path.reverse();
			}
			return [this.laneClosureRequest.changeRequest.organizationName];
		},
		groupedByParkingLaneId() {
			let groupedDataObject = this.laneClosureRequest.parkingRemoval.reduce((acc, item) => {
				const parkingLaneId = item.parkingLaneId.value;
				if (!acc[parkingLaneId]) {
					acc[parkingLaneId] = {
						parkingLaneId,
						parkingLaneText: LaneClosureRequest.getLaneText(parkingLaneId),
						parkingLaneImgUrl: LaneClosureRequest.getLaneImage(parkingLaneId),
						parkingLocations: [],
					};
				}
				acc[parkingLaneId].parkingLocations.push(item);
				return acc;
			}, {});
			return groupedDataObject;
		},
		isRemovingSelf: function() {
			if (this.laneClosureRequest) {
				if (this.removeContactIndex != null) {
					if (this.laneClosureRequest.contact[this.removeContactIndex]) {
						if (this.laneClosureRequest.contact[this.removeContactIndex].userId == this.$store.getters.userInfo().userId) {
							return true;
						}
					}
				}
			}
			return false;
		},

		canAddContact:function() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasPermission('lcr_add_contact_all')) {
					return true;
				}
				if (this.$store.getters.userHasPermission('lcr_add_contact_org')) {
					return true;
				}
				if (this.$store.getters.userHasPermission('lcr_add_contact_mine')) {
					return true;
				}
			}
			return false;
		},

		getTempTrafficControl() {
			let text = "";
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.tempTrafficControl.value == 1) {
					text = "Requires Temporary Traffic Control by Traffic Services";
				} else {
					text = "Does NOT want Temporary Traffic Control by Traffic Services";
				}
			}
			return text;
		},


		getAcaText() {
			let text = "";
			let comma = "";
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.actAsAca.value == 1) {
					text = "Acting as ACA for ";

					if (this.laneClosureRequest.acaParkingRemoval.value == 1) {
						text += comma + "Parking Removal";
						comma = ", ";
					}
					if (this.laneClosureRequest.acaTurnRestrictions.value == 1) {
						text += comma + "Turn Restrictions";
						comma = ", ";
					}
					if (this.laneClosureRequest.acaFullDirectional.value == 1) {
						text += comma + "Full or Directional Closure of a Regional Street";
						comma = ", ";
					}
					if (this.laneClosureRequest.acaDcz.value == 1) {
						text += comma + "DCZ";
						comma = ", ";
					}
				} else {
					text = "Not acting as ACA";
				}
			}
			return text;
		},
		getParkingSpotMapLink() {
			let comma = "";
			let link = this.$store.state.paidParkingLotMapUrl + "&ll=";
			if (this.laneClosureRequest) {
				for (var x = 0; x < this.$store.getters["map/polylines"].length; x++) {
					let polyBounds = this.$store.getters["map/polylines"][x].getPath();
					for (var z = 0; z < polyBounds.length; z++) {
						link += comma + polyBounds.getAt(z).lat() + "%2c" + polyBounds.getAt(z).lng();
						break;
					}
					break;
				}
				link += "&z=18";
				return link;
			}
			return null;
		},

		getBusStopMapLink() {
			let comma = "";
			let link = this.$store.state.busStopMapUrl + "&ll=";
			if (this.laneClosureRequest) {
				for (var x = 0; x < this.$store.getters["map/polylines"].length; x++) {
					let polyBounds = this.$store.getters["map/polylines"][x].getPath();
					for (var z = 0; z < polyBounds.length; z++) {
						link += comma + polyBounds.getAt(z).lat() + "%2c" + polyBounds.getAt(z).lng();
						break;
					}
					break;
				}
				link += "&z=18";
				return link;
			}
			return null;
		},
		durationConflict: function() {
			return this.laneClosureRequest.conflicts.filter(entry => {
				if (entry.conflictType === 'duration' && entry.requesterId !== this.laneClosureRequest.requesterId) {
					return true;
				}
			});
		},
		adjacentStartConflict: function() {
			return this.laneClosureRequest.conflicts.filter(entry => {
				if (entry.conflictType == 'adjacent_start_date' && entry.requesterId !== this.laneClosureRequest.requesterId) {
					return true;
				}
			});
		},
		adjacentEndConflict: function() {
			return this.laneClosureRequest.conflicts.filter(entry => {
				if (entry.conflictType == 'adjacent_end_date' && entry.requesterId !== this.laneClosureRequest.requesterId) {
					return true;
				}
			});
		},

		canSetTrafficEffect() {
			if (this.laneClosureRequest) {
				return this.$store.getters.userCanSetTrafficEffect();
			}
			return false;
		},
		canReportContravention() {
			// can't report contraventions for requested changes.
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.lcrChangeRequestId) {
					return false;
				}
			}

			if (this.laneClosureRequest) {
				return this.$store.getters.userCanReportContravention();
			}
			return false;
		},
		canCancelRequest() {
			// if (this.laneClosureRequest) {
			// 	if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userId() == this.laneClosureRequest.requesterId) {
			// 		if (this.laneClosureRequest.recordStatusId.value != 7) {
			// 			return true;
			// 		}
			// 	}
			// }
			// return false;

			let canReport = false;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canOrg = this.$store.getters.userHasPermission('lcr_update_org');
					let canMine = this.$store.getters.userHasPermission('lcr_update_mine');
					let canAll = this.$store.getters.userHasPermission('lcr_update_all');

					if (!canMine && !canAll && !canOrg) {
						return false;
					}

					if (canAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];
					if (!canReport) {
						if (canOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}
				}
			}
			return canReport;
		},
		canDuplicateRequest() {
			// if (this.laneClosureRequest) {
			// 	if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			// 		return true;
			// 	}
			// 	if (this.$store.getters.userId() == this.laneClosureRequest.requesterId) {
			// 		return true;
			// 	}
			// 	if (this.$store.getters.userInfo() && this.$store.getters.userInfo().userOrganizations.includes(this.laneClosureRequest.requester.organizationId)) {
			// 		return true;
			// 	}
			// }

			let canReport = false;
			if (this.laneClosureRequest) {
				// if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canOrg = this.$store.getters.userHasPermission('lcr_update_org');
					let canMine = this.$store.getters.userHasPermission('lcr_update_mine');
					let canAll = this.$store.getters.userHasPermission('lcr_update_all');

					if (!canMine && !canAll && !canOrg) {
						return false;
					}

					if (canAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}
				// }
			}
			return canReport;

		},

		canCompleteRequest() {
			let canReport = false;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canOrg = this.$store.getters.userHasPermission('lcr_update_org');
					let canMine = this.$store.getters.userHasPermission('lcr_update_mine');
					let canAll = this.$store.getters.userHasPermission('lcr_update_all');

					if (!canMine && !canAll && !canOrg) {
						return false;
					}

					if (canAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.closureReporterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altClosureReporter) {
							for (x = 0; x < this.laneClosureRequest.altClosureReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altClosureReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altClosureReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

				}
			}
			return canReport;

		},

		canReportRestriction() {
			// can't report restrictions for requested changes.
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.lcrChangeRequestId) {
					return false;
				}
			}

			let canReport = false;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canOrg = this.$store.getters.userHasPermission('rr_org');
					let canMine = this.$store.getters.userHasPermission('rr_mine');
					let canAll = this.$store.getters.userHasPermission('rr_all');

					if (!canMine && !canAll && !canOrg) {
						return false;
					}

					if (canAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.restrictionReporterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altRestrictionReporter) {
							for (x = 0; x < this.laneClosureRequest.altRestrictionReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRestrictionReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRestrictionReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

					if (canReport) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].restriction.length > 0) {
								return true;
							}
						}
					}
				}
			}
			return canReport;
		},

		hasChangeRequest() {
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.lcrChangeRequestId) {
					return true;
				}
			}
			return false;
		},




		canReportClosure() {

			// can't report closures for requested changes.
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.lcrChangeRequestId) {
					return false;
				}
			}

			let canReport = false;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canOrg = this.$store.getters.userHasPermission('rlc_org');
					let canMine = this.$store.getters.userHasPermission('rlc_mine');
					let canAll = this.$store.getters.userHasPermission('rlc_all');



					if (!canMine && !canAll && !canOrg) {
						return false;
					}

					if (canAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.closureReporterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canOrg || canMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altClosureReporter) {
							for (x = 0; x < this.laneClosureRequest.altClosureReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altClosureReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altClosureReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

					if (canReport) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].lane) {
								if (this.laneClosureRequest.block[x].lane.length > 0) {
									return true;
								}
							}
							if (this.laneClosureRequest.block[x].bicycle) {
								if (this.laneClosureRequest.block[x].bicycle.length > 0) {
									return true;
								}
							}
							if (this.laneClosureRequest.block[x].sidewalk) {
								if (this.laneClosureRequest.block[x].sidewalk.length > 0) {
									return true;
								}
							}
						}
					}
				}
			}
			return canReport;
		},



		googleMap: gmapApi,
		disableStartDate() {
			return {
						to: Format.utcToPickerDate(
								Format.startOfLocalDay().utc().format()
						)
			};
		},
		disableEndDate() {
			if (this.laneClosureRequest.fromDate &&
			this.laneClosureRequest.fromDate.value) {
				return {
					to: new Date(
					Format.utcToPickerDate(
					this.laneClosureRequest.fromDate.value
					).setHours(0, 0, 0, -1)
					)
				};
			}

			return {};
		},
		getEditRequestLink() {
			return "/lane-closure-request/" + this.laneClosureRequest.id + "/edit";
		},

		friendlyFromToDate() {
			// let diff = Format.diffYMDHMS(this.laneClosureRequest.fromDate.value, this.laneClosureRequest.toDate.value);
			return null;
		},
		directionOfTravel() {
			if (this.laneClosureRequest.directionId.value) {
				return Format.searchById(this.laneClosureRequest.directionId.value, LaneClosureRequest.getDirectionIdOptions).name;
			}
			return null;
		},
		getPeakIdText() {
			if (this.laneClosureRequest.peakId.value) {
				return Format.searchById(this.laneClosureRequest.peakId.value, LaneClosureRequest.getClosurePeakReason).name;
			}
			return null;
		},

		natureOfWork() {
			if (this.laneClosureRequest.natureOfWorkId.value) {
				return Format.searchById(this.laneClosureRequest.natureOfWorkId.value, LaneClosureRequest.getNatureOfWorkOptions).name;
			}
			return null;
		},
		transitFieldsState() {
			if (this.laneClosureRequest.transitAffected.status == null &&
				this.laneClosureRequest.transitOther.status == null &&
				this.laneClosureRequest.transitStopNumbers.status == null
			) {
				return null;
			}

			return false;
		},
		projectTimeDuration() {
			/*
			if (this.laneClosureRequest.fromDate.valid && this.laneClosureRequest.toDate.valid) {
				if (this.laneClosureRequest.fromDate.valid && this.laneClosureRequest.toTime.valid) {
					let startTime = Format.fromUtc(this.laneClosureRequest.fromDate.value);
					startTime.minutes(Number(this.laneClosureRequest.fromDate.value.mm));
					let startPmAddTime = (this.laneClosureRequest.fromDate.value.a == 'pm' && this.laneClosureRequest.fromDate.value.h != '12' ? 12 : 0);
					startPmAddTime = this.laneClosureRequest.fromDate.value.a == 'am' && this.laneClosureRequest.fromDate.value.h == '12' ? -12 : startPmAddTime;
					startTime.hours(Number(this.laneClosureRequest.fromTime.value.h) + startPmAddTime);

					let endTime = Format.fromUtc(this.laneClosureRequest.toDate.value);
					endTime.minutes(Number(this.laneClosureRequest.toTime.value.mm));
					let endPmAddTime = (this.laneClosureRequest.toTime.value.a == 'pm' && this.laneClosureRequest.toTime.value.h != '12' ? 12 : 0);
					startPmAddTime = this.laneClosureRequest.toTime.value.a == 'am' && this.laneClosureRequest.toTime.value.h == '12' ? -12 : startPmAddTime;
					endTime.hours(Number(this.laneClosureRequest.toTime.value.h) + endPmAddTime);

					// return Math.abs(this.moment.duration(startTime.diff(endTime)).asHours());
					return this.moment.duration(endTime.diff(startTime)).asHours();
				}
			}
			*/
			return null;
		},
	},

	watch: {
		'$route.params': function() {
			// for changing route within the same component
			this.unsavedChanges = false;
			this.LoadLaneClosureRequest(this.$route.params.id);
		},
		'laneClosureRequest.recordStatusId.value': function() {
			if (this.laneClosureRequest.recordStatusId.value == 7) {
				if (this.laneClosureRequest.completeTypeId.value == null) {

					if (this.laneClosureRequest.approvalStatusId.value == 1) {
						this.laneClosureRequest.completeTypeId.value = null;
					}
					if (this.laneClosureRequest.approvalStatusId.value == 2) {
						this.laneClosureRequest.completeTypeId.value = 2;
					}
					if (this.laneClosureRequest.approvalStatusId.value == 3) {
						this.laneClosureRequest.completeTypeId.value = 3;
					}
				}
			}
		},
		'laneClosureRequest.changeRequest.recordStatusId': function() {
			if (this.laneClosureRequest.changeRequest.recordStatusId == 7) {
				if (this.laneClosureRequest.changeRequest.completeTypeId == null) {

					if (this.laneClosureRequest.changeRequest.approvalStatusId == 1) {
						this.laneClosureRequest.changeRequest.completeTypeId = null;
					}
					if (this.laneClosureRequest.changeRequest.approvalStatusId == 2) {
						this.laneClosureRequest.changeRequest.completeTypeId = 2;
					}
					if (this.laneClosureRequest.changeRequest.approvalStatusId == 3) {
						this.laneClosureRequest.changeRequest.completeTypeId = 3;
					}
				}
			}
		},
		'laneClosureRequest.ownerId': function() {
			this.getOwnerProjects();
		},

		'laneClosureRequest.internalComments.value':function(newvalue, oldvalue) {
			if (typeof newvalue != "undefined" && typeof oldvalue != "undefined") {
				if (oldvalue != newvalue) {
					// console.log(oldvalue );
					// console.log(newvalue );
					this.unsavedChanges = true;
				}
			}
		},


		'statusMessage':function(newvalue, oldvalue) {
			if (typeof newvalue != "undefined" && typeof oldvalue != "undefined") {
				if (oldvalue != newvalue) {
					if (newvalue != null && newvalue != ""  && newvalue != "<br>") {
						// console.log("statusMessage");
						// console.log(oldvalue );
						// console.log(newvalue );
						this.unsavedChanges = true;
					}
				}
			}
		},

	},

	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {

		anyExpanded() {
			var isExpanded = false;
			if (this.expandTrafficSignalsAltered) {
				return true;
			}
			for (var x in this.expandCustomizeLane) {
				if (this.expandCustomizeLane[x] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}

			for (var x2 in this.expandCustomizeSidewalk) {
				if (this.expandCustomizeSidewalk[x2] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}
			for (var x3 in this.expandCustomizeBicycle) {
				if (this.expandCustomizeBicycle[x3] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}

			for (var x4 in this.expandCustomizeRestriction) {
				if (this.expandCustomizeRestriction[x4] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}
		},

		collapseAll() {
			this.expandCustomizeLane["40"] = false;
			this.expandCustomizeLane["41"] = false;
			this.expandCustomizeLane["42"] = false;
			this.expandCustomizeLane["43"] = false;

			this.expandCustomizeLane["1"] = false;
			this.expandCustomizeLane["2"] = false;
			this.expandCustomizeLane["24"] = false;
			this.expandCustomizeLane["25"] = false;
			this.expandCustomizeLane["3"] = false;
			this.expandCustomizeLane["15"] = false;
			this.expandCustomizeLane["32"] = false;
			this.expandCustomizeLane["33"] = false;
			this.expandCustomizeLane["19"] = false;
			this.expandCustomizeLane["4"] = false;
			this.expandCustomizeLane["5"] = false;
			this.expandCustomizeLane["26"] = false;
			this.expandCustomizeLane["27"] = false;
			this.expandCustomizeLane["6"] = false;
			this.expandCustomizeLane["16"] = false;
			this.expandCustomizeLane["34"] = false;
			this.expandCustomizeLane["35"] = false;
			this.expandCustomizeLane["20"] = false;
			this.expandCustomizeLane["7"] = false;
			this.expandCustomizeLane["8"] = false;
			this.expandCustomizeLane["28"] = false;
			this.expandCustomizeLane["29"] = false;
			this.expandCustomizeLane["9"] = false;
			this.expandCustomizeLane["17"] = false;
			this.expandCustomizeLane["36"] = false;
			this.expandCustomizeLane["37"] = false;
			this.expandCustomizeLane["21"] = false;
			this.expandCustomizeLane["10"] = false;
			this.expandCustomizeLane["11"] = false;
			this.expandCustomizeLane["30"] = false;
			this.expandCustomizeLane["31"] = false;
			this.expandCustomizeLane["12"] = false;
			this.expandCustomizeLane["22"] = false;
			this.expandCustomizeLane["18"] = false;
			this.expandCustomizeLane["38"] = false;
			this.expandCustomizeLane["39"] = false;
			this.expandCustomizeLane["13"] = false;
			this.expandCustomizeLane["14"] = false;
			this.expandCustomizeLane["23"] = false;

			this.expandCustomizeSidewalk["1"] = false;
			this.expandCustomizeSidewalk["2"] = false;
			this.expandCustomizeSidewalk["3"] = false;
			this.expandCustomizeSidewalk["4"] = false;

			this.expandCustomizeBicycle["1"] = false;
			this.expandCustomizeBicycle["2"] = false;
			this.expandCustomizeBicycle["3"] = false;
			this.expandCustomizeBicycle["4"] = false;
			this.expandCustomizeBicycle["5"] = false;
			this.expandCustomizeBicycle["6"] = false;
			this.expandCustomizeBicycle["7"] = false;
			this.expandCustomizeBicycle["8"] = false;

			this.expandCustomizeRestriction["1,1"] = false;
			this.expandCustomizeRestriction["1,2"] = false;
			this.expandCustomizeRestriction["1,3"] = false;
			this.expandCustomizeRestriction["1,4"] = false;
			this.expandCustomizeRestriction["2,1"] = false;
			this.expandCustomizeRestriction["2,2"] = false;
			this.expandCustomizeRestriction["2,3"] = false;
			this.expandCustomizeRestriction["2,4"] = false;
			this.expandCustomizeRestriction["3,1"] = false;
			this.expandCustomizeRestriction["3,2"] = false;
			this.expandCustomizeRestriction["3,3"] = false;
			this.expandCustomizeRestriction["3,4"] = false;
		},


		canRemoveContact(contact) {
			if (this.laneClosureRequest) {
				if (contact) {
					if (this.$store.getters.userHasPermission('lcr_remove_contact_all')) {
						return true;
					}
					if (this.$store.getters.userHasPermission('lcr_remove_contact_org')) {
						// compare the org id of the contact with the org id of the logged in user.
						// if both are in the tree, the logged in user's org must be at the same level or higher than the contacts.
						// see if any org
						let orgs = this.getOrganizationIdTreeList(contact);
						if (orgs.includes(""+this.$store.getters.userInfo().organizationId)) {
							return true;
						}
					}
					if (this.$store.getters.userHasPermission('lcr_remove_contact_mine')) {
						// can only remove themselves from the contact list...
						let orgs = this.getOrganizationIdTreeList(contact);
						if (orgs.includes(""+this.$store.getters.userInfo().organizationId)) {
							return true;
						}
					}
				}
			}
			return false;
		},
		hasAnyLane() {
			let found = false;
			let xx = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].sidewalk.length || this.laneClosureRequest.block[xx].lane.length || this.laneClosureRequest.block[xx].bicycle.length) {
						found = true;
					}
				}
			}
			return found;
		},

		toggleMessagesModal() {
			this.$refs['messages__modal'].show();
		},
		forceRerender() {
			this.renderCounter += 1;
			this.blockDetailsKey = "blockDetailsKey-" + this.renderCounter;
			this.blockClosuresRestrictionsKey = "blockClosuresRestrictionsKey-" + this.renderCounter;
			this.blockEditDetailsKey = "blockEditDetailsKey-" + this.renderCounter;
			this.forceRerenderBlockEditDetails();
		},
		forceRerenderBlockEditDetails() {
			this.blockEditDetailsKeyCounter += 1;
			this.blockEditDetailsKey = "blockEditDetailsKey-" + this.blockEditDetailsKeyCounter;
		},


		hasSidewalkId(id) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].sidewalk) {
						for (x = 0; x < this.laneClosureRequest.block[xx].sidewalk.length; x++) {
							if (this.laneClosureRequest.block[xx].sidewalk[x].sidewalkId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}
			if (found == false) {
				// see if they have preset
				for (xx = 0; xx < this.laneClosureRequest.presetBlock.length; xx++) {
					if (this.laneClosureRequest.presetBlock[xx].sidewalk) {
						for (x = 0; x < this.laneClosureRequest.presetBlock[xx].sidewalk.length; x++) {
							if (this.laneClosureRequest.presetBlock[xx].sidewalk[x].sidewalkId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}
			return found;
		},
		hasLaneId(id) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.presetBlock[0].lane.length; xx++) {
					if (this.laneClosureRequest.presetBlock[0].lane[xx].laneId.value == id) {
						return true;
					}
				}


				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].lane) {
						for (x = 0; x < this.laneClosureRequest.block[xx].lane.length; x++) {
							if (this.laneClosureRequest.block[xx].lane[x].laneId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}

			if (found == false) {
				// see if they have preset
				for (xx = 0; xx < this.laneClosureRequest.presetBlock.length; xx++) {
					if (this.laneClosureRequest.presetBlock[xx].lane) {
						for (x = 0; x < this.laneClosureRequest.presetBlock[xx].lane.length; x++) {
							if (this.laneClosureRequest.presetBlock[xx].lane[x].laneId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}


			return found;
		},

		hasBicycleId(id) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].bicycle) {
						for (x = 0; x < this.laneClosureRequest.block[xx].bicycle.length; x++) {
							if (this.laneClosureRequest.block[xx].bicycle[x].bicycleLaneId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}
			if (found == false) {
				// see if they have preset
				for (xx = 0; xx < this.laneClosureRequest.presetBlock.length; xx++) {
					if (this.laneClosureRequest.presetBlock[xx].bicycle) {
						for (x = 0; x < this.laneClosureRequest.presetBlock[xx].bicycle.length; x++) {
							if (this.laneClosureRequest.presetBlock[xx].bicycle[x].bicycleLaneId.value + "" == "" + id) {
								found = true;
							}
						}
					}
				}
			}
			return found;
		},
		hasRestrictions() {
			let found = false;
			let xx = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].restriction) {
						if (this.laneClosureRequest.block[xx].restriction.length > 0) {
							found = true;
						}
					}
				}
				if (found == false) {
					for (xx = 0; xx < this.laneClosureRequest.presetBlock.length; xx++) {
						if (this.laneClosureRequest.presetBlock[xx].restriction) {
							if (this.laneClosureRequest.presetBlock[xx].restriction.length > 0) {
								found = true;
							}
						}
					}
				}
			}
			return found;
		},
		hasRestrictionTypeId(id, directionId) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].restriction) {
						for (x = 0; x < this.laneClosureRequest.block[xx].restriction.length; x++) {
							if (this.laneClosureRequest.block[xx].restriction[x].restrictionTypeId.value + "" == "" + id &&
								this.laneClosureRequest.block[xx].restriction[x].directionId.value + "" == "" + directionId) {
								found = true;
							}
						}
					}
				}
				if (found == false) {
					// see if they have preset
					for (xx = 0; xx < this.laneClosureRequest.presetBlock.length; xx++) {
						if (this.laneClosureRequest.presetBlock[xx].restriction) {
							for (x = 0; x < this.laneClosureRequest.presetBlock[xx].restriction.length; x++) {
								if (this.laneClosureRequest.presetBlock[xx].restriction[x].restrictionTypeId.value + "" == "" + id &&
									this.laneClosureRequest.presetBlock[xx].restriction[x].directionId.value + "" == "" + directionId) {
									found = true;
								}
							}
						}
					}
				}
			}
			return found;
		},

		showNewProjectModalOkClick() {
			this.SaveNewProject();
		},
		SaveNewProject() {
			// TODO: Do we clear the first cross street and last cross street?
			// fill the first cross and last cross street names...
			if (!this.isButtonDisabled) {
				this.isButtonDisabled = true;
				let data = {
					organizationId: this.laneClosureRequest.owner.organizationId,
					name: this.newProject.name.value,
					isActive: this.newProject.isActive.value ? 1 : 0,
					comments: this.newProject.comments.value
				}
				Vue.prototype.$http.post(this.$store.state.apiUrl + '/project', data)
					.then(resp => {
						this.laneClosureRequest.ownerProjectId.value = resp.data.id;
						this.ownerProjectInfo = resp.data;
						this.showNewProjectModal = false;
						this.newProject.name.value = null;
						this.newProject.comments.value = null;
						this.getOwnerProjects();
						this.isButtonDisabled = false;
					})
					.catch(error => {})
			}

		},

		projectSelectChanged() {
			this.laneClosureRequest.ownerProjectId.resetStatus();
			this.unsavedChanges = true;
		},
		closeEditProjectModal() {
			this.showEditProjectModal = false;
		},
		openEditProjectModal() {
			if (this.laneClosureRequest.ownerProjectId.value > 0) {
				let curProject = this.ownerProjectIdOptions.find(x => x.id == this.laneClosureRequest.ownerProjectId.value);
				this.editProject.name.value = curProject.name;
				this.editProject.isActive.value = curProject.isActive;
				this.editProject.comments.value = curProject.comments;
				this.editProject.id = curProject.id;
				this.showEditProjectModal = true;
			}
		},
		showEditProjectModalOkClick() {
			this.SaveEditProject();
		},
		SaveEditProject() {
			if (!this.isButtonDisabled) {
				this.isButtonDisabled = true;
				let data = {
					id: this.editProject.id,
					organizationId: this.laneClosureRequest.owner.organizationId,
					name: this.editProject.name.value,
					isActive: this.editProject.isActive.value ? 1 : 0,
					comments: this.editProject.comments.value
				}
				Vue.prototype.$http.put(this.$store.state.apiUrl + '/project/' + this.editProject.id, data)
					.then(resp => {
						this.laneClosureRequest.ownerProjectId.value = resp.data.id;
						this.requesterProjectInfo = resp.data;
						this.showEditProjectModal = false;
						this.editProject.id = null;
						this.editProject.name.value = null;
						this.editProject.comments.value = null;
						this.editProject.isActive.value = null;
						this.isButtonDisabled = false;
						this.getOwnerProjects();
					})
					.catch(error => {})
			}
		},
		ArchiveProject() {
			if (!this.isButtonDisabled) {
				this.isButtonDisabled = true;
			let data = {
				id: this.editProject.id,
				organizationId: this.laneClosureRequest.owner.organizationId,
				name: this.editProject.name.value,
				isActive: 0,
				comments: this.editProject.comments.value
			}
			Vue.prototype.$http.put(this.$store.state.apiUrl + '/project/' + this.editProject.id + "/archive", data)
				.then(resp => {
					this.laneClosureRequest.ownerProjectId.value = resp.data.id;
					this.requesterProjectInfo = resp.data;
					this.showEditProjectModal = false;
					this.editProject.id = null;
					this.editProject.name.value = null;
					this.editProject.comments.value = null;
					this.editProject.isActive.value = null;
					this.isButtonDisabled = false;
					this.getOwnerProjects();
				})
				.catch(error => {})
			}
		},
		RestoreProject() {
			if (!this.isButtonDisabled) {
				this.isButtonDisabled = true;
			let data = {
				id: this.editProject.id,
				organizationId: this.laneClosureRequest.owner.organizationId,
				name: this.editProject.name.value,
				isActive: 0,
				comments: this.editProject.comments.value
			}
			Vue.prototype.$http.put(this.$store.state.apiUrl + '/project/' + this.editProject.id + "/restore", data)
				.then(resp => {
					this.laneClosureRequest.ownerProjectId.value = resp.data.id;
					this.requesterProjectInfo = resp.data;
					this.showEditProjectModal = false;
					this.editProject.id = null;
					this.editProject.name.value = null;
					this.editProject.comments.value = null;
					this.editProject.isActive.value = null;
					this.isButtonDisabled = false;
					this.getOwnerProjects();
				})
				.catch(error => {})
			}
		},

		getOwnerProjects() {
			Vue.prototype.$http.post(this.$store.state.apiUrl + '/project/assignable', { userId: this.laneClosureRequest.ownerId })
				.then(resp => {
					if (resp.data.length == 0) {
						this.ownerProjectIdOptions = [];
						this.ownerProjectIdOptions.push({
							id: null,
							name: "No Project Assigned",
							displayName: "No Project Assigned",
							isActive: 1
						});
						this.laneClosureRequest.ownerProjectId.value = null;

					} else {
						this.ownerProjectIdOptions = [];
						this.ownerProjectIdOptions.push({
							id: null,
							name: "No Project Assigned",
							displayName: "No Project Assigned",
							isActive: 1
						});
						for (var x = 0; x < resp.data.length; x++) {
							let projectX = Object.assign({}, resp.data[x]);
							if (resp.data[x].isActive == 0) {
								projectX.displayName = projectX.name + " (Archived)";
								this.ownerProjectIdOptions.push(projectX);
							} else {
								projectX.displayName = projectX.name;
								this.ownerProjectIdOptions.push(projectX);
							}
							// this.ownerProjectIdOptions.push(resp.data[x]);
						}
					}
				})
				.catch(error => {})
		},


		updateRequesterProjectLabel() {
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.requester) {
					this.projectLabel = this.laneClosureRequest.requester.organizationName + " Project";
				} else {
					this.projectLabel = "Project";
				}
			} else {
				this.projectLabel = "Project";
			}
		},


		canSeeWarning() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasRole('manager_requests') || this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
					return true;
				}
			}
			return false;
		},
		canChangeStatus() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasRole('internal_admin_requests')) {
					return true;
				}
			}
			return false;
		},


		setEventBusOff() {
			this.$bus.$off('markLaneClosureCompleted', this.PostCompleteLaneClosureRequest);
			this.$bus.$off('markLaneClosureCancelled', this.PostCancelLaneClosureRequest);
			this.$bus.$off('toggleMessagesModal', this.toggleMessagesModal);

			this.$bus.$off('view-lcr:map:block-click', this.onMapBlockClick);
			this.$bus.$off('view-lcr:map:block-edit', this.onMapBlockEdit);
			this.$bus.$off('message:newMessage', this.sendNewMessage);
			this.$bus.$off('lane-closure-request:edit-contravention', this.editContravention);
			this.$bus.$off('lane-closure-request:view-contravention', this.viewContravention);

			this.$bus.$off('block:list-expand-lane', this.onToggleExpandCustomizeLane);
			this.$bus.$off('block:list-expand-sidewalk', this.onToggleExpandCustomizeSidewalk);
			this.$bus.$off('block:list-expand-bicycle', this.onToggleExpandCustomizeBicycle);
			this.$bus.$off('block:list-expand-restriction', this.onToggleExpandCustomizeRestriction);
			this.$bus.$off('block:list-expand-trafficSignalsAltered', this.onToggleExpandTrafficSignalsAltered);
			this.$bus.$off('block:show-on-map', this.showBlockOnMap);
			this.$bus.$off('block:report-lane-closure', this.onReportLaneClosure);
			this.$bus.$off('block:report-restriction',  this.onReportRestriction);


			this.$bus.$off('map:nearbyLoaded', this.nearbyLoaded);

			this.$bus.$off('map:shown', this.changeToHideMap);
			this.$bus.$off('map:hidden', this.changeToShowMap);

			this.$lcrHub.$off('new-notification', this.receivedNotification);

			this.$bus.$off('swipe:right', this.onSwipeRight);


			// hide the map when leaving.
			Vue.prototype.$bus.$emit("map:toggle", 0);
		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on('markLaneClosureCompleted', this.PostCompleteLaneClosureRequest);
			this.$bus.$on('markLaneClosureCancelled', this.PostCancelLaneClosureRequest);
			this.$bus.$on('toggleMessagesModal', this.toggleMessagesModal);

			this.$bus.$on('view-lcr:map:block-click', this.onMapBlockClick);
			this.$bus.$on('view-lcr:map:block-edit', this.onMapBlockEdit);
			this.$bus.$on('message:newMessage', this.sendNewMessage);
			this.$bus.$on('lane-closure-request:edit-contravention', this.editContravention);
			this.$bus.$on('lane-closure-request:view-contravention', this.viewContravention);

			this.$bus.$on('block:list-expand-lane', this.onToggleExpandCustomizeLane);
			this.$bus.$on('block:list-expand-sidewalk', this.onToggleExpandCustomizeSidewalk);
			this.$bus.$on('block:list-expand-bicycle', this.onToggleExpandCustomizeBicycle);
			this.$bus.$on('block:list-expand-restriction', this.onToggleExpandCustomizeRestriction);
			this.$bus.$on('block:list-expand-trafficSignalsAltered', this.onToggleExpandTrafficSignalsAltered);
			this.$bus.$on('block:show-on-map', this.showBlockOnMap);

			this.$bus.$on('block:report-lane-closure', this.onReportLaneClosure);
			this.$bus.$on('block:report-restriction', this.onReportRestriction);
			this.$bus.$on('map:nearbyLoaded', this.nearbyLoaded);

			this.$bus.$on('map:shown', this.changeToHideMap);
			this.$bus.$on('map:hidden', this.changeToShowMap);

			this.$bus.$on('swipe:right', this.onSwipeRight);


			this.$lcrHub.$on('new-notification', this.receivedNotification);
		},
		showCompleteRequestModal() {
			this.showCompletedModal = true;
		},

		onEditRequestedChanges() {
			if (this.laneClosureRequest.id && this.laneClosureRequest.lcrChangeRequestId) {
				this.$router.push({ name: "EditRequestedChanges", params: { id: this.laneClosureRequest.id } });
			}
		},

		onShowDiscardChangesModal() {
			this.showDiscardChangesModal = true;
		},
		showCancelRequestModal() {
			this.showCancelModal = true;
		},

		onSetStatusChangeRequest() {
			this.postSetStatusChangeRequest(true);
		},

		onSetStatus() {
			this.postSetStatus(true);
		},

		onSetTrafficEffect() {
			this.postTrafficEffect(true);
		},



		showOnMap() {
			Vue.prototype.$bus.$emit("map:toggle", null, this.hideMap ? 0 : 1);
			// this.$nextTick(() => {
			// 	this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);
			// 	this.setAllPolylineColours();
			// });
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToNearbyRequestById", this.laneClosureRequest.id);
			});
		},



		showRequestOnMap(id) {
			Vue.prototype.$bus.$emit("map:toggle", null, 1);
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToNearbyRequestById", id);
			});
		},

		showRequestOnMapThenLoadNearby(id, openMap) {
			let that = this;
			this.$nextTick(() => {
				if (openMap) {
					Vue.prototype.$bus.$emit("map:toggle", null, 1);
				}
				that.$store.commit("map/setLoadNearbyBounds", false)
				that.$store.commit('map/clearNearbyPolylines', {});  /// hmmmmm...
				// just zoom all the blocks then...
				let boundsLL = new google.maps.LatLngBounds();
				let x = 0;
				let z = 0;
				for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
					if (that.$store.getters["map/polylines"][x]) {
						let polyBounds = that.$store.getters["map/polylines"][x].getPath();
						for (z = 0; z < polyBounds.length; z++) {
							boundsLL.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
						}
					}
				}
				let bounds = boundsLL.toJSON();
				if (that.$store.getters["map/zoom"] > 10) {
					bounds = that.$store.getters["map/bounds"].toJSON();
				}
				let distance = that.$store.getters["map/nearbyRadius"]  * 0.1 / 10000;  // 3 km around
				bounds.south = bounds.south - distance;
				bounds.north = bounds.north + distance;
				bounds.west = bounds.west - distance;
				bounds.east = bounds.east + distance;

				that.$store.dispatch("map/setNearbyBounds", bounds).then(() => {
						// setTimeout(() => {
							that.$store.dispatch("map/zoomToNearbyRequestById", that.laneClosureRequest.id).then(() => {
									that.$store.dispatch("map/setLoadNearbyBounds", true).then(() => {
										// that.loadNearbyBounded(bounds);
										Vue.prototype.$bus.$emit("map:loadNearbyBounded", bounds);
									});
							});
						// }, 1000);
				});
			});
		},

		showRequestOnMapThenLoadNearbyOLD(id) {
			let that = this;
			this.$nextTick(() => {
				Vue.prototype.$bus.$emit("map:toggle", null, 1);
				this.$store.dispatch("map/zoomToNearbyRequestById", id);
				setTimeout(() => {

					let bounds = that.$store.getters["map/bounds"].toJSON();
					let distance = that.$store.getters["map/nearbyRadius"]  * 0.1 / 10000;  // 3 km around
					bounds.south = bounds.south - distance;
					bounds.north = bounds.north + distance;
					bounds.west = bounds.west - distance;
					bounds.east = bounds.east + distance;
					that.$store.commit("map/setNearbyBounds", bounds);
					Vue.prototype.$bus.$emit("map:loadNearbyBounded", bounds);
				}, 500);

			});
		},


		nearbyLoaded() {
			// this.LoadLaneClosureRequest(this.$route.params.id);
		},

		showBlockOnMap(data) {
			let id;
			if (data instanceof Object) {
				id = data.id;
			} else {
				id = data;
			}
			if (this.currentBlockOnMap && this.currentBlockOnMap instanceof Object) {
				if (this.currentBlockOnMap.id == data.id && this.currentBlockOnMap.type == data.type && this.currentBlockOnMap.laneId == data.laneId) {
					if (this.currentBlockOnMap.type == "restriction") {
						if (this.currentBlockOnMap.streetName == data.streetName) {
							Vue.prototype.$bus.$emit("map:toggle", 0);
							this.currentBlockOnMap = null;
							return;
						}
					} else {
						Vue.prototype.$bus.$emit("map:toggle", 0);
						this.currentBlockOnMap = null;
						return;
					}
				}
			}
			this.currentBlockOnMap = data;
			Vue.prototype.$bus.$emit("map:toggle", 1);
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToBlockId", id);
				for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == id) {
						this.zoomToBlock(x);
						this.setPolylineColours(x);
						break;
					}
				}
			});
		},

		postTrafficEffect(showSaveChanges) {
			if (showSaveChanges) {
				this.savedChanges = false;
			}
			this.isButtonDisabled = true;
			if (!this.saving) {
				this.saving = true;
				let obj = {
					trafficEffect: this.laneClosureRequest.trafficEffect.getRawValue()
				}
				Vue.prototype.$http({
					url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/traffic-effect?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					method: 'post',
					data: obj
				}).then(resp => {
					this.PostTrafficEffectSuccess();
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.laneClosureRequest.SetErrors(error.response.data);
						this.errorDetails = error.response.data;
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				}).finally(() => {
					if (showSaveChanges) {
						this.savedChanges = true;
						this.saving = false;
						this.unsavedChanges = true;
					}
					this.saving = false;
					this.isButtonDisabled = false;
				});
			}
		},
		PostTrafficEffectSuccess() {
			// this.LoadLaneClosureRequest(this.$route.params.id);
		},

		postSetStatusUnderReview() {
			this.savedChanges = false;
			this.isButtonDisabled = true;
			if (!this.saving) {
				this.saving = true;
				let obj = {
					recordStatusId: this.laneClosureRequest.recordStatusId.value,
					approvalStatusId: this.laneClosureRequest.approvalStatusId.value,
					completeTypeId: this.laneClosureRequest.completeTypeId.value,
					ownerId: this.laneClosureRequest.ownerId,
					ownerProjectId: this.laneClosureRequest.ownerProjectId.value,
					message: this.statusMessage,
					displayTime: this.laneClosureRequest.displayTime.value,
					internalComments: this.laneClosureRequest.internalComments.value,
				}
				return Vue.prototype.$http({
					url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/status?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					method: 'post',
					data: obj
				}).then(resp => {
					this.laneClosureRequest.recordStatusId.value = resp.data.recordStatusId;
					this.laneClosureRequest.approvalStatusId.value = resp.data.approvalStatusId;
					this.laneClosureRequest.completeTypeId.value = resp.data.completeTypeId;
					this.saving = false;
					this.LoadLaneClosureRequest(this.$route.params.id);
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.laneClosureRequest.SetErrors(error.response.data);
						this.errorDetails = error.response.data;
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				}).finally(() => {
					this.savedChanges = true;
					this.saving = false;
					this.isButtonDisabled = false;
					this.settingToUnderReview = false;
					this.unsavedChanges = false;
				});
			}
		},

		postSetStatusChangeRequest(showSaveChanges) {
			if (this.laneClosureRequest.changeRequest == null) {
				return;
			}
			if (showSaveChanges) {
				this.savedChanges = false;
			}
			this.isButtonDisabled = true;

			if (!this.saving) {
				this.saving = true;
			let obj = {
				recordStatusId: this.laneClosureRequest.changeRequest.recordStatusId,
				approvalStatusId: this.laneClosureRequest.changeRequest.approvalStatusId,
				completeTypeId: this.laneClosureRequest.changeRequest.completeTypeId,
				changeRequestId: this.laneClosureRequest.changeRequest.id,
				ownerId: this.laneClosureRequest.ownerId,
				ownerProjectId: this.laneClosureRequest.ownerProjectId.value,
				message: this.statusMessage,
				displayTime: this.laneClosureRequest.displayTime.value,
				internalComments: this.laneClosureRequest.internalComments.value,
			}
			return Vue.prototype.$http({
				url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/crstatus?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
				method: 'post',
				data: obj
			}).then(resp => {
				this.laneClosureRequest.recordStatusId.value = resp.data.recordStatusId;
				this.laneClosureRequest.approvalStatusId.value = resp.data.approvalStatusId;
				this.laneClosureRequest.completeTypeId.value = resp.data.completeTypeId;
				this.PostStatusSuccess();
			}).catch(error => {
				if (!ErrorHandler.HasLoginErrorCode(error)) {
					// this.laneClosureRequest.SetErrors(error.response.data);
					this.errorDetails = error.response.data;
					this.showErrors(error.response.data.fields);
				} else {
					// ErrorHandler.RedirectToLogin();
				}
			}).finally(() => {
				if (showSaveChanges) {
					this.savedChanges = true;
					this.saving = false;
				}
				this.isButtonDisabled = false;
			});
			}
		},



		postSetStatus(showSaveChanges) {
			if (showSaveChanges) {
				this.savedChanges = false;
			}
			this.isButtonDisabled = true;

			if (!this.saving) {
				this.saving = true;
			let obj = {
				recordStatusId: this.laneClosureRequest.recordStatusId.value,
				approvalStatusId: this.laneClosureRequest.approvalStatusId.value,
				completeTypeId: this.laneClosureRequest.completeTypeId.value,
				ownerId: this.laneClosureRequest.ownerId,
				ownerProjectId: this.laneClosureRequest.ownerProjectId.value,
				message: this.statusMessage,
				displayTime: this.laneClosureRequest.displayTime.value,
				internalComments: this.laneClosureRequest.internalComments.value,
			}
			return Vue.prototype.$http({
				url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/status?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
				method: 'post',
				data: obj
			}).then(resp => {
				this.laneClosureRequest.recordStatusId.value = resp.data.recordStatusId;
				this.laneClosureRequest.approvalStatusId.value = resp.data.approvalStatusId;
				this.laneClosureRequest.completeTypeId.value = resp.data.completeTypeId;
				this.PostStatusSuccess();
			}).catch(error => {
				if (!ErrorHandler.HasLoginErrorCode(error)) {
					// this.laneClosureRequest.SetErrors(error.response.data);
					this.errorDetails = error.response.data;
					this.showErrors(error.response.data.fields);
				} else {
					// ErrorHandler.RedirectToLogin();
				}
			}).finally(() => {
				if (showSaveChanges) {
					this.savedChanges = true;
					this.saving = false;
				}
				this.isButtonDisabled = false;
			});
			}
		},
		PostStatusSuccess() {
			this.unsavedChanges = false;
			let lastPage = this.$routerStore.getters['getLastListPage'];
			if (lastPage == null) {
				this.$router.push({ name: "LaneClosureList" });
			} else {
				this.$router.push(lastPage);
			}
		},

		editContravention(obj) {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "EditContravention", params: { id: this.laneClosureRequest.id, contraventionId: obj.id } });
			}

		},

		viewContraventions(obj) {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "LaneClosureRequestContraventions", params: { id: this.laneClosureRequest.id } });
			}
		},

		viewContravention(obj) {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ViewContravention", params: { id: this.laneClosureRequest.id, contraventionId: obj.id } });
			}
		},

		viewLaneClosureRequest(id) {
			if (id) {
				this.$router.push({ name: "ViewLaneClosureRequest", params: { id: id } });
			}
		},

		onViewLaneClosureRequest() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
			}
		},



		onViewUpdates() {
			this.GetAllUpdates(this.laneClosureRequest.id);
		},

		onViewRecent() {
			this.GetLatestUpdates(this.laneClosureRequest.id).then((response) => {
				this.$nextTick(() => {
					var main = document.getElementById("main");
					var jumpTo = document.getElementById("updatesList");
					main.scrollTo(0, jumpTo.offsetTop);
				});
			});
		},



		sendNewMessage(obj) {
			if (obj.message != null && obj.message != "") {
				if (!this.sendingMessage) {
					this.sendingMessage = true;
					Vue.prototype.$http({
						method: 'post',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/new-message?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						data: obj
					}).then(resp => {
						this.laneClosureRequest.message = [];
						let x = 0;
						for (x = 0; x < resp.data.length; x++) {
							this.laneClosureRequest.message.push(new LaneClosureRequestMessage(resp.data[x]));
						}
						this.PostNewMessageSuccess();
						obj.done(true)
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.laneClosureRequest.SetErrors(error.response.data);
							this.errorDetails = error.response.data;
							this.showErrors(error.response.data.fields);
						} else {
							// ErrorHandler.RedirectToLogin();
						}
					}).finally(() => {
						this.isButtonDisabled = false;
						this.sendingMessage = false;
					});
				}
			}
		},
		PostNewMessageSuccess() {

		},


		zoomAllBlocks() {
			this.$store.dispatch("map/zoomAllBlocks", null);
		},
		zoomToLaneClosureRequest() {
			this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);
			// this.setAllPolylineColours();
		},
		zoomToBlock(index) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			let x = 0;
			let z = 0;
			if (this.laneClosureRequest.block[index]) {
				if (this.$store.getters["map/polylines"]) {
					for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
						if (this.$store.getters["map/polylines"][x]) {
							if (this.$store.getters["map/polylines"][x].blockData) {
								if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[index].blockId) {
									let polyBounds = this.$store.getters["map/polylines"][x].getPath();
									for (z = 0; z < polyBounds.length; z++) {
										bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
									}
									setBounds = true;
								}
							}
						}
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},

		zoomToBlockId(id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			if (this.laneClosureRequest.block) {
				let x = 0;
				let z = 0;
				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].mapPolyline && this.laneClosureRequest.block[x].blockId == id) {
						let polyBounds = this.laneClosureRequest.block[x].mapPolyline.getPath();
						for (z = 0; z < polyBounds.length; z++) {
							bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
						}
						setBounds = true;
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},
		setPolylineColours(index) {
			return;
			/*
			let x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[index].blockId) {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#F2B942' });
						} else {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });
						}
					}
				}
			}
			*/
		},
		setAllPolylineColours() {
			return;
			/*
			let x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });
					}
				}
			}
			*/
		},

		onSwipeRight() {
			// if the sub transitions are open, close them, otherwise go back.
			if (this.anyExpanded()) {
				Vue.prototype.$bus.$emit("swipe:right:panel",null);
			} else {
				this.$router.go(-1);
				// TODO: should we go back to list instead?
			}
		},


		setBlockPolyline(block) {
			let that = this;
			let foundIndex = null;
			let blockPolyline = null;
			if (block) {
				// find the existing marker/placemark.
				if (this.laneClosureRequest.block) {
					for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
						if (this.laneClosureRequest.block[x].blockId == block.blockId) {
							foundIndex = x;
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											blockPolyline = that.$store.getters["map/polylines"][x];
										}
									}
								}
							}
						}
					}
				}



				if (foundIndex == null || blockPolyline == null) {
					// add the block to the map.
					// look for existing block in lane closure request, and select it.
					var myParser = new Vue.prototype.$geoXML3.parser({
						map: null,
						afterParse: function(doc) {
							let xx = 0;
							var coords = [];
							let zz = 0;
							for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
								for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
									coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
								}
							}

							let mapPolyline = new google.maps.Polyline({
								map: that.$store.state.map.map,
								path: coords,
								strokeColor: '#666666',
								strokeOpacity: 1.0,
								strokeWeight: 8
							});
							mapPolyline.blockData = block;
							// mapPolyline.laneClosureRequest = that.laneClosureRequest;
							mapPolyline.laneClosureRequest = new LaneClosureRequestListEntry(that.laneClosureRequest.getRawValue());

							let mapIndex = -1;
							if (foundIndex == null) {
								let newBlock = new LaneClosureRequestBlock(block);
								that.laneClosureRequest.block.push(newBlock);
								foundIndex = that.laneClosureRequest.block.length - 1;
							}
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											that.$store.commit("map/setPolylineByIndex", x, mapPolyline);
											mapIndex = x;
										}
									}
								}
							}
							if (mapIndex == -1) {
								// not found, so add the polyline.
								that.$store.commit("map/addPolyline", mapPolyline);
							}
							google.maps.event.addListener(mapPolyline, 'click', function(e) {
								that.$bus.$emit('map:nearby-block-popup', { polyline: this, e: e });
							});

							return;
						}
					});
					let kmlString = "";
					if (block.kml != "") {
						let color = "7fff0000";
						if (block.streetName != that.laneClosureRequest.affectedStreet.value) {
							// turning restriction
							color = "7f000000"
						}
						kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
						kmlString = KMLHelper.finalizeKml(kmlString);
						myParser.parseKmlString(kmlString);
					}
				}
			}
		},


		onMapBlockEdit: function(id) {
			if (typeof this.$refs.blockDetails != "undefined") {
				this.$refs.blockDetails.selectBlockById(id);
			}
		},
		onMapBlockClick: function(evt) {
			if (evt.blockData) {
				// we clicked a block!
				//
				// check if we have the block defined
				let x = 0;
				let found = false;
				for (x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == evt.blockData.blockId) {
						found = true;
					}
				}
				if (!found) {
					// let's add it back in
					evt.setMap(null);
					this.setBlockPolyline(evt.blockData);
				} else {
					if (typeof this.$refs.blockDetails != "undefined") {
						this.$refs.blockDetails.editBlockById(evt.blockData.blockId);
					}
				}
			}
		},


		getLaneText(laneId) {
			if (laneId) {
				return Format.searchByGroupedId(laneId, LaneClosureRequest.getLaneAffectedOptions).name;
			}
			return null;
		},

		getParkingLaneRemovedText(laneId) {
			if (laneId) {
				return Format.searchById(laneId, LaneClosureRequest.getParkingLaneOptions).name;
			}
			return null;
		},

		getBidAdmin() {
			if (this.laneClosureRequest.bidAdmin.value != null && this.laneClosureRequest.bidAdmin.value != "") {
				return this.laneClosureRequest.bidAdmin.value;
			} else {
				return "N/A";
			}
		},

		getTransitText(transitId) {
			if (transitId !== null) {
				var transit = Format.searchById(transitId, LaneClosureRequest.getAffectTransitOptions);
				if (transit) {
					return transit.name;
				}
			}
			return null;
		},

		getCustomParkingRemovalText() {
			if (this.laneClosureRequest) {
				switch(this.laneClosureRequest.parkingRemovalId.value) {
					case 1:
						return 	"YES, TRAFFIC SERVICES";
					case 2:
						return 	"NO";
					case 3:
						return 	"STREETS AND URBAN FORESTRY";
					case 4:
						return 	"FILM AND SPECIAL EVENTS OFFICE";
					case 5:
						return 	"YES, AUTHORIZED CONSTRUCTION AGENCY";
				}
			}
			return null;
		},


		getParkingRemovalText(parkingRemovalId) {
			if (parkingRemovalId !== null) {
				return Format.searchById(parkingRemovalId, LaneClosureRequest.getViewParkingRemoveOptions).name;
			}
			return null;
		},
		getWorkDoneForText(path) {
			if (path) {
				return Format.pipesToFlatTree(path.toUpperCase());
			}
			return null;
		},



		getRestrictionTypeText(restrictionTypeId) {
			if (restrictionTypeId) {
				return Format.searchById(restrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).name;
			}
			return null;
		},

		getLeftTurnSignalText(turn) {
			if (turn !== null) {
				return Format.searchById(turn, LaneClosureRequest.getYesNoOptions).name;
			}
			return "N/A";
		},

		getYesNoText(val) {
			if (val !== null) {
				return Format.searchById(val, LaneClosureRequest.getYesNoOptions).name;
			}
			return null;
		},

		getSidewalkText(sidewalkId) {
			if (sidewalkId) {
				return Format.searchById(sidewalkId, LaneClosureRequest.getSidewalkOptions).name;
			}
			return "N/A";
		},

		getDczRequiredText(dcz) {
			if (dcz) {
				return Format.searchById(dcz, LaneClosureRequest.getYesNoOptions).name;
			}
			return "N/A";
		},

		getBicycleText(bicycleId) {
			if (bicycleId) {
				return Format.searchById(bicycleId, LaneClosureRequest.getAffectBicycleOptions).name;
			}
			return "N/A";
		},


		emailHref(value) {
			return "mailto:" + value;
		},

		onReportLaneClosure() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ReportClosure", params: { id: this.laneClosureRequest.id } });
			}
		},

		onReportRestriction() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ReportRestriction", params: { id: this.laneClosureRequest.id } });
			}
		},

		onReportContravention() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ReportContravention", params: { id: this.laneClosureRequest.id } });
			}
		},

		// required fields notifying modal
		modalRequiredFieldClose() {
			this.showRequiredFieldModal = false;
		},

		showErrors(errors) {
			this.submissionStatus = 'submission-error';
			this.modalRequiredFieldList = [];
			for (let field in errors) {
				this.modalRequiredFieldList.push(errors[field]);
			}
			if (this.modalRequiredFieldList.length > 0) {
				this.showRequiredFieldModal = true;
			} else {
				this.showLoadErrorModal = true;

			}
		},

		showLoadErrors(errors) {
			this.submissionStatus = 'submission-error';
			this.modalRequiredFieldList = [];
			for (let field in errors) {
				this.modalRequiredFieldList.push(errors[field]);
			}
			this.showLoadErrorModal = true;
		},

		onOwnerSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/owners?q=' + encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		// Addeds a transaction line with contact attached.
		onOwnerSelect(selected) {
			this.laneClosureRequest.ownerId = parseInt(selected.userId);
			this.laneClosureRequest.owner = selected;
			this.$refs.searchOwner.value = "";
			this.unsavedChanges = true;
		},

		openWarningModal() {
			this.$refs.warningModal.openModal();
		},

		onDuplicateRequest() {
			// TODO:  alert if there are still closed lanes or in-place restrictions.
			// this.$bus.$emit("show-modal-under-development", {title:"Under Development", body:"This will pass the existing details to the new lane closure request form."});

			if (this.laneClosureRequest) {
				this.$router.push({ name: "DuplicateLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
			}


		},

		onCloseLoadErrorModal() {
			this.showLoadErrorModal = false;
			this.$router.push({ name: "LaneClosureList" });
		},

		onCancelRequest() {
			// TODO:  alert if there are still closed lanes or in-place restrictions.
			this.PostCancelLaneClosureRequest(this.laneClosureRequest);
		},
		PostCancelLaneClosureRequest(t) {
			this.cancelSaving = true;
			if (t instanceof LaneClosureRequest) {
				if (!this.isButtonDisabled) {
				this.isButtonDisabled = true;
				let go = true;
				if (go) {
					Vue.prototype.$http({
						method: 'post',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${t.id}/cancelled?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					}).then(resp => {
						this.CancelLaneclosureRequestSuccess();
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.laneClosureRequest.SetErrors(error.response.data);
							this.errorDetails = error.response.data;
							this.showErrors(error.response.data.fields);
							this.cancelSaving = false;
						} else {
							// ErrorHandler.RedirectToLogin();
						}
					}).finally(() => {
						this.isButtonDisabled = false;
					});
				}
				}
			}
		},

		CancelLaneclosureRequestSuccess() {
			this.cancelSaving = false;
			let lastPage = this.$routerStore.getters['getLastListPage'];
			if (lastPage == null) {
				this.$router.push({ name: "LaneClosureList" });
			}
			return this.$router.push(lastPage);
			// this.LoadLaneClosureRequest(this.$route.params.id);
		},



		onDiscardChanges() {
			// TODO:  alert if there are still closed lanes or in-place restrictions.
			this.PostDiscardChanges(this.laneClosureRequest);
		},

		PostDiscardChanges(t) {
			this.completeSaving = true;
			if (t instanceof LaneClosureRequest) {
				this.isButtonDisabled = true;
				let go = true;
				if (go) {
					Vue.prototype.$http({
						method: 'put',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${t.id}/discard-requested-changes/${t.lcrChangeRequestId}?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					}).then(resp => {
						this.DiscardChangesRequestSuccess();
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.laneClosureRequest.SetErrors(error.response.data);
							this.errorDetails = error.response.data;
							this.showErrors(error.response.data.fields);
							this.completeSaving = false;
						} else {
							// ErrorHandler.RedirectToLogin();
						}
					}).finally(() => {
						this.isButtonDisabled = false;
					});
				}
			}
		},
		DiscardChangesRequestSuccess() {
			this.completeSaving = false;
			this.LoadLaneClosureRequest(this.$route.params.id);
		},





		onCompleteRequest() {
			// TODO:  alert if there are still closed lanes or in-place restrictions.
			this.PostCompleteLaneClosureRequest(this.laneClosureRequest);
		},

		PostCompleteLaneClosureRequest(t) {
			this.completeSaving = true;
			if (t instanceof LaneClosureRequest) {
				this.isButtonDisabled = true;
				let go = true;
				if (go) {
					Vue.prototype.$http({
						method: 'post',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${t.id}/completed?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					}).then(resp => {
						this.CompleteLaneclosureRequestSuccess();
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.laneClosureRequest.SetErrors(error.response.data);
							this.errorDetails = error.response.data;
							this.showErrors(error.response.data.fields);
							this.completeSaving = false;
						} else {
							// ErrorHandler.RedirectToLogin();
						}
					}).finally(() => {
						this.isButtonDisabled = false;
					});
				}
			}
		},

		CompleteLaneclosureRequestSuccess() {
			this.completeSaving = false;
			this.LoadLaneClosureRequest(this.$route.params.id);
		},

		getContactResult(result) {
			// don't show it in the dropdown.
			return "";
		},

		onContactSearch(input) {
			return new Promise((resolve, reject) => {
				if (input.length < 1) {
					return resolve([])
				}
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/level-assignable?q=' + encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		onContactSelect(selected) {
			// add the selected contact to the alternate listing, with a delete button as well.
			let found = false;
			for (var entry in this.laneClosureRequest.contact) {
				if (this.laneClosureRequest.contact[entry].userId == selected.userId) {
					// already in the list.
					found = true;
				}
			}
			this.$refs.searchContact.value = null;
			if (!found) {
				// attach the new contact to the LCR
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/add-contact/${selected.userId}?r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					this.laneClosureRequest.contact.push(selected);
					this.$refs.searchContact.value = "";
				}).catch(error => {

					// if (!ErrorHandler.HasLoginErrorCode(error)) {
					// 	if (error.response && error.response.data) {
					// 		this.loaded = false;
					// 		this.transactionStatus = 'load-error';
					// 		this.errorDetails = error.response.data;
					// 	}
					// } else {
					// 	// ErrorHandler.RedirectToLogin();
					// }
				});
			}
		},
		onRemoveContact(index) {
			this.showRemoveContactModal = true;
			this.removeContactIndex = index;
		},

		onConfirmRemoveContact() {
			// attach the new contact to the LCR
			this.isButtonDisabled = true;
			Vue.prototype.$http({
				method: 'post',
				url: Format.getApiUrl("/lane-closure-request/" + this.id + "/remove-contact/" + this.laneClosureRequest.contact[this.removeContactIndex].userId)
			}).then(response => {
				this.laneClosureRequest.contact.splice(this.removeContactIndex, 1);
				this.removeContactIndex = null;
				this.isButtonDisabled = false;
			}).catch(error => {
				if (!ErrorHandler.HasLoginErrorCode(error)) {
					if (error.response && error.response.data) {
						this.loaded = false;
						this.transactionStatus = 'load-error';
						this.errorDetails = error.response.data;
					}
				} else {
					// ErrorHandler.RedirectToLogin();
				}
			});
		},
		onCancelRemoveContact() {
			this.removeContactIndex = null;
			this.showRemoveContactModal = false;
		},

		GetAllUpdates(id) {
			this.loadingUpdates = true;
			return Vue.prototype.$http({
				method: 'get',
				url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/all-updates?r=${Math.round(Math.random() * Math.pow(10, 6))}`
			}).then(response => {
				this.auditBatches = response.data.data;
				this.auditBatchCount = response.data.count;
				this.loadingUpdates = false;
				this.forceRerender();
			});
		},


		GetLatestUpdates(id) {
			this.loadingUpdates = true;
			return Vue.prototype.$http({
				method: 'get',
				url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/latest-updates?r=${Math.round(Math.random() * Math.pow(10, 6))}`
			}).then(response => {
				this.loadingUpdates = false;
				this.auditBatches = response.data.data;
				this.auditBatchCount = response.data.count;
				this.forceRerender();

			});
		},


		setToUnderReviewIfRequired() {
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.recordStatusId.value == 2 && this.canChangeStatus()) { // New, automatically set it to Under Review
					this.laneClosureRequest.recordStatusId.value = 3;
					this.settingToUnderReview = true;
					return this.postSetStatusUnderReview();
				} else {
					return new Promise((resolve, reject) => {
						resolve();
					});
				}
			}
		},

		LoadLaneClosureRequest(id = this.id) {
			this.loaded = false;
			// Remove any messages being displayed.
			let that = this;
			if (!that.$store.getters.isLoggedIn) {
				return;
			}

			this.submissionStatus = null;
			if (id && Format.TryParseInt(id) > 0) {
				this.GetLaneClosureRequest(id).then((result) => {
					this.$store.dispatch('map/setActiveLcrId', id);
					return this.setToUnderReviewIfRequired().then((result) => {
						return this.GetLatestUpdates(id);
					})
				}).finally(() => {
					this.loaded = true;
					this.loadError = false;
					this.$nextTick(() => {
							if (this.scrollToRef != null) {
								var main = document.getElementById("main");
								if (this.scrollToRef == "newMessage") {
									main.scrollTo(0, this.$refs.newMessage.$el.offsetParent.offsetTop);
								}
							}
							that.$store.dispatch("map/setAllNearbyPolylineWeight").then(function() {
								that.$store.dispatch("map/setZindexesForPolylines").then(function() {
									that.$store.dispatch('map/buildOverlapIcons', {});
								});
								});


						if (that.laneClosureRequest) {
							if (that.laneClosureRequest.approvalStatusId.value == 1 && that.loaded == true && that.laneClosureRequest.recordStatusId.value != 7) {
								if (that.$store.getters.userHasRole('internal_admin_requests') || that.$store.getters.userHasRole('system_admin')) {
									that.showRequestOnMapThenLoadNearby(this.laneClosureRequest.id, true);
								} else {
									// Vue.prototype.$bus.$emit("map:loadNearby", 1);
								}
							} else  {
								if (that.$store.getters.userHasRole('internal_admin_requests') || that.$store.getters.userHasRole('system_admin')) {

									that.showRequestOnMapThenLoadNearby(this.laneClosureRequest.id, false);


								}
							}
						}
					});
				});
			}
		},
		// Loads lane closure request into the component based on provided id.
		GetLaneClosureRequest(id) {
			if (Format.TryParseInt(id)) {
				this.loaded = false;
				return Vue.prototype.$http({
					method: 'get',
					url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/view-requested-changes?r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					this.laneClosureRequest = new LaneClosureRequest(response.data.request);
					if (typeof response.data.changeRequest != "undefined") {
						if (response.data.changeRequest != null) {
							this.laneClosureRequest.changeRequest = response.data.changeRequest;
						} else {
							this.laneClosureRequest.changeRequest = null;
						}
					} else {
							this.laneClosureRequest.changeRequest = null;
						}
					this.storeLCR();
					if (this.laneClosureRequest.block) {
						this.laneClosureRequest.conflictsFromOthers = this.laneClosureRequest.conflicts.filter(entry => {
							if (entry.requesterId !== this.laneClosureRequest.requesterId) {
								return true;
							}
						});
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							this.setBlockPolyline(this.laneClosureRequest.block[x]);
						}
						this.zoomToLaneClosureRequest();
					}
				}).catch(error => {
					// console.log("view error");
					// console.log(typeof error);
					// console.log(error);
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						if (error.response && error.response.data) {
							this.loadError = true;
							this.laneClosureRequest = new LaneClosureRequest();
							this.loaded = true;
							this.transactionStatus = 'load-error';
							this.errorDetails = error.response.data;
							this.showLoadErrors(error.response.data.fields);
						} else {
							if (ErrorHandler.HasConnectionError(error)) {
								Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
								this.loadError = true;
								this.laneClosureRequest = new LaneClosureRequest();
								this.loaded = true;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
								this.showLoadErrors(error.response.data.fields);
							}
						}
					}
				});
			} else {
				return new Promise((resolve, reject) => {
					resolve();
				});
			}
		},

		onToggleExpandDCZ(value) {
			this.expandDCZ = !this.expandDCZ;
			this.forceRerender();
		},

		onToggleExpandParking(value) {
			this.expandParking = !this.expandParking;
			this.forceRerender();
		},
		onToggleExpandPermit(value) {
			this.expandPermit = !this.expandPermit;
			this.forceRerender();
		},
		onToggleExpandConflicts(value) {
			this.expandConflicts = !this.expandConflicts;
			this.forceRerender();
		},


		onToggleExpandTransit(value) {
			this.expandTransit = !this.expandTransit;
			this.forceRerender();
		},

		onToggleExpandTrafficSignalsAltered(value) {
			this.expandTrafficSignalsAltered = !this.expandTrafficSignalsAltered;
			this.forceRerender();
		},

		onToggleExpandCustomizeLane(value) {
			this.expandCustomizeLane["" + value.laneId] = value.expand;
			this.forceRerender();
		},
		onToggleExpandCustomizeSidewalk(value) {
			this.expandCustomizeSidewalk["" + value.sidewalkId] = value.expand;
			this.forceRerender();
		},
		onToggleExpandCustomizeBicycle(value) {
			this.expandCustomizeBicycle["" + value.bicycleLaneId] = value.expand;
			this.forceRerender();
		},
		onToggleExpandCustomizeRestriction(value) {
			this.expandCustomizeRestriction["" + value.restrictionTypeId + "," + value.directionId] = value.expand;
			this.forceRerender();
		},


		changeRequestRecordStatusChanged() {
			if (this.laneClosureRequest.changeRequest.recordStatusId == 5) {
				this.laneClosureRequest.changeRequest.approvalStatusId = 2;
			}

			if (this.laneClosureRequest.changeRequest.recordStatusId == 7) {
				if (this.laneClosureRequest.changeRequest.approvalStatusId == 1) {
					this.laneClosureRequest.changeRequest.completeTypeId = 4;
				}
				if (this.laneClosureRequest.changeRequest.approvalStatusId == 2) {
					this.laneClosureRequest.changeRequest.completeTypeId = 2;
				}
				if (this.laneClosureRequest.changeRequest.approvalStatusId == 3) {
					this.laneClosureRequest.changeRequest.completeTypeId = 3;
				}
			}

			this.unsavedChanges = true;
		},
		recordStatusChanged() {
			if (this.laneClosureRequest.recordStatusId.value == 5) {
				this.laneClosureRequest.approvalStatusId.value = 2;
			}
			this.unsavedChanges = true;
		},




	changeRequestApprovalStatusChanged() {
		if (this.laneClosureRequest.changeRequest.approvalStatusId == 1) {
			this.laneClosureRequest.changeRequest.recordStatusId = 3;
		}
		if (this.laneClosureRequest.changeRequest.approvalStatusId == 2) {
			this.laneClosureRequest.changeRequest.recordStatusId = 7;
			this.laneClosureRequest.changeRequest.completeTypeId = 2;
		}
		if (this.laneClosureRequest.changeRequest.approvalStatusId == 3) {
			this.laneClosureRequest.changeRequest.recordStatusId = 3;
		}
		this.unsavedChanges = true;
	},


		approvalStatusChanged() {
			if (this.laneClosureRequest.approvalStatusId.value == 1) {
				this.laneClosureRequest.recordStatusId.value = 3;
			}
			if (this.laneClosureRequest.approvalStatusId.value == 2) {
				this.laneClosureRequest.recordStatusId.value = 5;
			}
			if (this.laneClosureRequest.approvalStatusId.value == 3) {
				this.laneClosureRequest.recordStatusId.value = 3;
			}
			this.unsavedChanges = true;
		},

		canChangeInternalComments() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
					return true;
				}
			}
			return false;
		},

		getOrganizationTreeList(user) {
			if (user.organizationTree) {
				let treeString = user.organizationTree;
				let treeList = treeString.split("|");
				treeList.pop();
				treeList.shift();
				treeList.reverse();
				return treeList;
			} else {
				return new Array(user.organizationName);
			}
		},

		getOrganizationIdTreeList(user) {
			if (user.organizationIdTree) {
				let treeString = user.organizationIdTree;
				let treeList = treeString.split("|");
				treeList.pop();
				treeList.shift();
				treeList.reverse();
				return treeList;
			} else {
				return new Array(user.organizationId);
			}
		},

		changeToHideMap(x) {
			this.hideMap = true;
		},
		changeToShowMap(x) {
			this.currentBlockOnMap = null;
			this.hideMap = false;
		},

		onContactKeydown(event) {
			const { key } = event;
			if (key == "Tab") {
				if (this.$refs.searchContact.value)
					this.onContactSelect(this.$refs.searchContact.value);
			}
		},

		receivedNotification(notification) {
			if (notification.lcrId && this.laneClosureRequest.id == notification.lcrId) {
				if (notification.notificationTypeId == 'lcr-new-message') {
					this.getMessages();
				} else if (notification.notificationTypeId == 'lcr-changes-requested') {
					this.showLaneClosureRequestUpdated = true;
				} else if (notification.notificationTypeId == 'lcr-updated') {
					this.showLaneClosureRequestUpdated = true;
				} else if (notification.notificationTypeId == 'lcr-status-updated') {
					this.showLaneClosureRequestUpdated = true;
				} else if (notification.notificationTypeId == 'lcr-completed') {
					this.showLaneClosureRequestUpdated = true;
				} else if (notification.notificationTypeId == 'lcr-cancelled') {
					this.showLaneClosureRequestUpdated = true;
				} else if (notification.notificationTypeId == 'lcr-approved') {
					this.showLaneClosureRequestUpdated = true;
				} else if (notification.notificationTypeId == 'lcr-denied') {
					this.showLaneClosureRequestUpdated = true;
				} else if (notification.notificationTypeId == 'new-lcr') {
					this.showLaneClosureRequestUpdated = true;
				}
			}
		},

		getMessages() {
			Vue.prototype.$http({
				method: 'get',
				url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/messages?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
			}).then(resp => {
				this.laneClosureRequest.message = [];
				let x = 0;
				for (x = 0; x < resp.data.messages.length; x++) {
					this.laneClosureRequest.message.push(new LaneClosureRequestMessage(resp.data.messages[x]));
				}
			}).catch(error => {
				if (!ErrorHandler.HasLoginErrorCode(error)) {
					// this.laneClosureRequest.SetErrors(error.response.data);
					this.errorDetails = error.response.data;
					this.showErrors(error.response.data.fields);
				} else {
					// ErrorHandler.RedirectToLogin();
				}
			});
		},

		refreshLCR() {
			this.showLaneClosureRequestUpdated = false;
			this.LoadLaneClosureRequest(this.$route.params.id);
		},

		getReminderNotifications() {
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.notification) {
					let laneClosureRequest = this.laneClosureRequest;
					// console.log(laneClosureRequest);
					let notifications = this.laneClosureRequest.notification;
					let displayNotification = [];

					let firstLcNotOpened = notifications.filter(x => x.notificationTypeId == 'lc-not-opened')[0];
					let firstRNotRemoved = notifications.filter(x => x.notificationTypeId == 'r-not-removed')[0];

					if (firstLcNotOpened) {
						firstLcNotOpened.text = Format.searchByKeyInArray(firstLcNotOpened.notificationTypeId, 'id', LaneClosureRequest.getNotificationTypeIdOptions).name;
						firstLcNotOpened.text = firstLcNotOpened.text.formatUnicorn(
							laneClosureRequest.id,
							Format.toLocalDateTime(laneClosureRequest.fromDate.value, "MMM DD"),
							Format.toLocalDateTime(laneClosureRequest.fromDate.value, "H:mm"),
							Format.toLocalDateTime(laneClosureRequest.toDate.value, "MMM DD"),
							Format.toLocalDateTime(laneClosureRequest.toDate.value, "H:mm"),
							firstLcNotOpened.date,
							moment(laneClosureRequest.fromDate.value).fromNow(),
							moment(laneClosureRequest.toDate.value).fromNow()
						);
						displayNotification.push(firstLcNotOpened);
					}
					if (firstRNotRemoved) {
						firstRNotRemoved.text = Format.searchByKeyInArray(firstRNotRemoved.notificationTypeId, 'id', LaneClosureRequest.getNotificationTypeIdOptions).name;
						firstRNotRemoved.text = firstRNotRemoved.text.formatUnicorn(
							laneClosureRequest.id,
							Format.toLocalDateTime(laneClosureRequest.fromDate.value, "MMM DD"),
							Format.toLocalDateTime(laneClosureRequest.fromDate.value, "H:mm"),
							Format.toLocalDateTime(laneClosureRequest.toDate.value, "MMM DD"),
							Format.toLocalDateTime(laneClosureRequest.toDate.value, "H:mm"),
							firstRNotRemoved.date,
							moment(laneClosureRequest.fromDate.value).fromNow(),
							moment(laneClosureRequest.toDate.value).fromNow()
						);
						displayNotification.push(firstRNotRemoved);
					}

					if (displayNotification.length > 0) {
						return displayNotification;
					}

					const REMINDER_TYPES = ['lc-r-reminder-closed', 'lc-r-reminder-opened', 'r-reminder-place', 'r-reminder-remove', 'lc-reminder-open', 'lc-reminder-close'];

					for (let i in REMINDER_TYPES) {
						let curType = REMINDER_TYPES[i];
						let filteredNotification = notifications.filter(x => x.notificationTypeId == curType)[0];

						if (filteredNotification) {
							filteredNotification.text = Format.searchByKeyInArray(filteredNotification.notificationTypeId, 'id', LaneClosureRequest.getNotificationTypeIdOptions).name;
							filteredNotification.text = filteredNotification.text.formatUnicorn(
								laneClosureRequest.id,
								Format.toLocalDateTime(laneClosureRequest.fromDate.value, "MMM DD"),
								Format.toLocalDateTime(laneClosureRequest.fromDate.value, "H:mm"),
								Format.toLocalDateTime(laneClosureRequest.toDate.value, "MMM DD"),
								Format.toLocalDateTime(laneClosureRequest.toDate.value, "H:mm"),
								filteredNotification.date,
								moment(laneClosureRequest.fromDate.value).fromNow(),
								moment(laneClosureRequest.toDate.value).fromNow()
							);

							displayNotification.push(filteredNotification);
						}
					}

					return displayNotification;
				}
			}

			return [];
		},
		getReminderNotificationClass(entries) {
			for (let i in entries) {
				let type = entries[i].notificationTypeId;
				if (type == 'lc-not-opened' || type == 'r-not-removed') {
					return 'warning';
				}
			}

			return 'reminder';
		},

		storeLCR() {
			this.$store.commit('laneClosureRequest/setData', this.laneClosureRequest);
		},

	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			// Vue.prototype.$bus.$emit("map:clear", 1);
			// Vue.prototype.$bus.$emit("map:showMapWhenDesktop");
			if (this) {
				if (!this.$store.getters.isLoggedIn) {
					return;
				}
				vm.LoadLaneClosureRequest(this.$route.params.id);
			}
		});
	},
	beforeRouteLeave(to, from, next) {
		this.overrideUnsavedChanges = true;
		this.$store.dispatch('map/setActiveLcrId', null);
		if (this.unsavedChanges) {
			this.showUnsavedChangesModal = true;
			this.modalOnSave = (function() {
				this.onSubmit().then(() => {
					// Vue.prototype.$bus.$emit("map:clear", 1);
					this.setEventBusOff();
					next(true);
				}).catch(() => {
					next(false);
				});
			}).bind(this);

			this.modalOnLeave = (function() {
				this.showUnsavedChangesModal = false;
				// Vue.prototype.$bus.$emit("map:clear", 1);
				this.setEventBusOff();
				next(true);
			}).bind(this);

			this.modalOnCancel = (function() {
				this.showUnsavedChangesModal = false;
				next(false);
			}).bind(this);
			next(false);
		} else {
			if (this.loaded && this.laneClosureRequest.hasChanges()) {
				if (this.overrideUnsavedChanges) {
					// Vue.prototype.$bus.$emit("map:clear", 1);
					this.setEventBusOff();
					next(true);
				} else {
					this.showUnsavedChangesModal = true;
					this.modalOnSave = (function() {
						this.onSubmit().then(() => {
							// Vue.prototype.$bus.$emit("map:clear", 1);
							this.setEventBusOff();
							next(true);
						}).catch(() => {
							next(false);
						});
					}).bind(this);

					this.modalOnLeave = (function() {
						this.showUnsavedChangesModal = false;
						// Vue.prototype.$bus.$emit("map:clear", 1);
						this.setEventBusOff();
						next(true);
					}).bind(this);

					next(false);
				}
			} else {
				// Vue.prototype.$bus.$emit("map:clear", 1);
				this.setEventBusOff();
				next(true);
			}
		}
	},


}
</script>
<i18n>
	{
	"en-CA": {
	}
	}
</i18n>